import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import TemplatePopup from './ORDMTemplatepage';
import DatePicker from 'react-datepicker'; // Import the DatePicker component for tge date in the form
import "react-datepicker/dist/react-datepicker.css";
import calendarIcon from '../../assest/images/10.jpg'
import Select from 'react-select';
import '../Login.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import viewIcon from '../../assest/images/eye.png';
import 'jspdf-autotable';
import Icon3 from "../../assest/images/Icon3.png";
import Icon5 from "../../assest/images/Icon5.png";
import accept from "../../assest/images/accept.png";
import OrderDropdown from '../common/OrderDropdown';
import { UserContext } from '../common/UserContext';
import config from '../../envconfig';
import { IoCaretUpOutline, IoCaretDownOutline, IoCalendarOutline } from 'react-icons/io5';
import { Check } from "lucide-react";
import x from '../../assest/images/x.png';
import Image from '../common/image';
import { FaPlus } from "react-icons/fa";
import ReactDOM from "react-dom/client";
import ReactSelectDropDown from '../common/ReactSelectDropDown';
import CustomDropdown from '../common/CustomDropdown';
import { set } from 'date-fns';

const OrderForm = () => {
    // State variables for using the function in code 
    const moment = require('moment');
    const [TemplateUse, setTemplateUse] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [createdbyscp, setcreatedbyscp] = useState();
    const [ORDM_OrderStatus, setORDM_OrderStatus] = useState();
    const [errormsgOrderQuantity, seterrormsgOrderQuantity] = useState('');
    const [OrderTypeTemp, setOrderTypeTemp] = useState(false);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [selectedorderType, setselectedorderType] = useState(1);
    const [cellValue, setCellValue] = useState('Click to edit');
    const [selectedTemplate, setselectedTemplate] = useState([]);
    const [productcode, setproductcode] = useState('');
    const [productid, setproductid] = useState('');
    const [availableQuantity, setavailableQuantity] = useState([]);
    const [scpNames, setscpNames] = useState([]);
    const [templateData, setTemplateData] = useState([]);
    const [aurdittaril, setaurdittaril] = useState(true);
    const inputRef = useRef(null);
    const [scpOptions, setScpOptions] = useState([]);
    const [scpcode, setscpcode] = useState('');
    const [selectedScpName, setSelectedScpName] = useState('');
    const [isQuantityvalid, setisQuantityvalid] = useState(false);
    const initialScpNames = [];
    const [dropdownKeyprdname, setDropdownKeyprdname] = useState(0);
    const [ord, setord] = useState();
    const [dropdownKey, setDropdownKey] = useState(0);
    const [filteredScpNames, setFilteredScpNames] = useState(initialScpNames);
    const [isOrderPopupOpen, setIsOrderPopupOpen] = useState(false); // State for controlling the visibility of the OrderPopup
    const [tempOrderQuantity, setTempOrderQuantity] = useState('');
    const [productNames, setProductNames] = useState([]);
    const [selectedProductName, setSelectedProductName] = useState('');
    const [filteredProductNames, setFilteredProductNames] = useState([]);
    const [isToDropdownDisabled, setIsToDropdownDisabled] = useState(false);
    const [orderDate, setOrderDate] = useState(formatDate(new Date()));
    const [showspan, setshowspan] = useState(false);
    const [isSchemeModalOpen, setIsSchemeModalOpen] = useState(false);
    const [schemeData, setSchemeData] = useState([]);
    const [offersFetched, setOffersFetched] = useState(false);
    const [schemes, setSchemes] = useState([]);

    const [appliedSchemes, setAppliedSchemes] = useState({});
    const [selectedSchemeId, setSelectedSchemeId] = useState(null);
    const [dropdownKeyfscp, setDropdownKeyfscp] = useState(0);
    const [FromScps, setFromScps] = useState([]);
    const [fromSCP, setfromSCP] = useState();
    const [toscps, settoscps] = useState();
    const location = useLocation();
    const [selectedFromScp, setSelectedFromScp] = useState(null); // 👈 track selected dropdown option
    const [tickerMessages, setTickerMessages] = useState([]);
    const [Status, setStatus] = useState();

    const [showconfimationModal, setshowconfimationModal] = useState(false);

    const BYSCP = location.state?.BYSCP ?? null;

    const handleOrderDateChange = (date) => {
        //ordnumgen(data);

        const formatteddate = formatDate(date) // Debugging: Log the new date to check if it's changing
        setOrderDate(formatteddate);
        setIsOpen(false)



    };

    const OptionsFromScp = FromScps.map(group => ({
        label: group.SCPM_Name,
        value: group.SCPM_Name
    }))

    useEffect(() => {
        const fetchData = async () => {

            try {
                const response = await axios.get(`${config.API_URL}/OM/api/scpmaster/${UM_CompanyID}`);

                const data = response.data
                setFromScps(data)
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };
        fetchData();
    }, []);
    const handleFromScpChange = (e) => {
        const selectedValue = e.target.value;  // NEW 👈

        setSelectedFromScp(selectedValue);
        setfromSCP(selectedValue);
        document.getElementById('fscp').style.display = 'none';

        const result = FromScps.find(item => item.SCPM_Name === selectedValue);
        let id = result?.SCPM_ID;

        setSelectedfromScpName(id);
        setSelectedScpName(null);
        setIsToDropdownDisabled(false);
        setDropdownKey(prevKey => prevKey + 1);

        if (id) {
            fetch(`${config.API_URL}/OM/ToSCP/${id}`)
                .then(response => response.json())
                .then(data => {
                    settoscps(data);

                    const SCPs = data.SCPs;
                    console.log("SCPs data", SCPs)
                    const scpNamesArray = SCPs.map(scp => scp.SCPM_Name);
                    setScpOptions(scpNamesArray);
                    setFilteredScpNames(SCPs);
                    setscpNames(SCPs);
                })
                .catch(error => console.error('Error fetching SCP names:', error));
        }

        fetch(`${config.API_URL}/OM/ProductList/${selectedScpId}`)
            .then(response => response.json())
            .then(data => setavailableQuantity(data.PL_ProductName))
            .catch(error => console.error('Error fetching product names:', error));

        logAction(`HandleFromScpChange (): ${selectedValue}`);
        ordnumgen();
    };

    const options = filteredScpNames.map(group => ({
        label: group.SCPM_Name,
        value: group.SCPM_ID
    }));

    const optionsproduct = filteredProductNames.map(group => ({
        label: group.PL_ProductName,
        value: group.PL_ProductName,
        code: group.PL_ProductCode // Adding code property to use in filter
    }));

    const handleApplyScheme = async (scheme, options = {}) => {
        const isAuto = options.isAuto || false;
        const orderData = options.orderData || orderTableData;

        setIsSaving(true);

        if (!isAuto && !scheme.isEligible) {
            setIsSaving(false);
            return;
        }

        // Unapply logic
        if (!isAuto && selectedSchemeId === scheme.SM_ID) {
            setSelectedSchemeId(null);
            setAppliedSchemes({});
            setIsSaving(false);
            return;
        }
        // Replace another scheme if already selected
        if (selectedSchemeId && selectedSchemeId !== scheme.SM_ID) {
            const previousScheme = schemeData.find((s) => s.SM_ID === selectedSchemeId);

            toast.success(
                `Scheme : ${scheme.SM_SchemeName} applied successfully.`, { onClose: () => setIsSaving(false) }
            );
        } else if (!isAuto) {
            toast.success(`Scheme : ${scheme.SM_SchemeName} applied successfully.`, { onClose: () => setIsSaving(false) });
        }

        // Calculate multiplier
        const isCombination = parseInt(scheme.SM_IsCombinationRequired) === 1;


        const multipliers = scheme.requiredProducts.map((req, idx) => {


            const orderedProduct = orderData.find(
                (item) =>
                    String(item.productid) === String(req.SPM_ProductID) ||
                    item.ProductName === req.ProductName
            );

            if (!orderedProduct) {
                console.warn(
                    `❌ Ordered product not found for required product ID ${req.SPM_ProductID}`
                ); setIsSaving(false);
                return 0;
            }

            const buyQty = Number(req.SPM_Quantity);
            if (!buyQty || buyQty <= 0) {
                console.warn(
                    `⚠️ SPM_Quantity is zero or invalid for product ${req.SPM_ProductID}`
                ); setIsSaving(false);
                return 0;
            }

            const orderedQty = Number(orderedProduct.OrderQuantity) || 0;

            const multiplier = Math.floor(orderedQty / buyQty);


            return multiplier;
        });



        let multiplier = 0;
        if (multipliers.length > 0) {
            multiplier = isCombination
                ? Math.min(...multipliers.filter((m) => m > 0)) || 0
                : Math.max(...multipliers) || 0;
        }



        // Prepare applied scheme object
        const appliedScheme = {
            discount: scheme.SM_Discount,
            giftArticle: null,
            DiscountType: scheme.SM_DiscountType,
            freeProducts: [],
        };

        if (scheme.SM_GiftArticle) {
            appliedScheme.giftArticle = {
                name: scheme.SM_GiftArticle,
                quantity: (parseInt(scheme.SM_Quantity || 1) || 1) * multiplier,
            };

        }

        if (scheme.freeProducts?.length > 0) {
            appliedScheme.freeProducts = scheme.freeProducts.map((fp) => ({
                freeProductId: fp.SFPM_ProductID || fp.productid || fp.id,
                freeProductName: fp.PL_ProductName,
                freeQuantity: (parseInt(fp.SFPM_Quantity || 0) || 0) * multiplier,
                freeProductCode: fp.ProductCode
            }));


        }



        setSelectedSchemeId(scheme.SM_ID);
        setAppliedSchemes({
            [scheme.SM_ID]: appliedScheme,
        });


    };

    const logAction = async (action, isError = false) => {

        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Order Master (by SCP)", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };
    // Function to format the date to YYYY-MM-DD HH:MM:SS
    const [isDisabled, setIsDisabled] = useState(false);
    const [isDateDisabled, setIsDateDisabled] = useState(false);
    const [orderQuantity, setOrderQuantity] = useState('');
    let OrderNumber;
    const [orderTableData, setOrderTableData] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOrderType, setSelectedOrderType] = useState('1');
    const [isResetMode, setIsResetMode] = useState(false);
    const [selectedfromScpName, setSelectedfromScpName] = useState('');
    const [selectedfromScpLevelNo, setselectedfromScpLevelNo] = useState('');
    //    const { UM_GroupId, UM_CompanyGrpID, UM_UserCode, UM_CompanyID, selectedScpId, UM_UserId } = useParams(); //73/2/2/3/3/CRK
    // const { UM_GroupId, UM_CompanyID, UM_CompanyGrpID, UM_UserId, UM_UserCode, selectedScpId } = useParams();
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const [isSelectOpen, setIsSelectOpen] = useState(null);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };
    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
    const [orderTypes, setOrderType] = useState([]);
    // Function for editing order quantity (popup )
    // Function to open the popup when clicking on use order template button
    function formatDate(dateString) {
        const originalDate = new Date(dateString);
        const formattedDate = moment(originalDate).format('YYYY-MM-DD HH:mm:ss');
        return formattedDate;
    }

    useEffect(() => {
        const fetchOrderStatus = async () => {
            try {
                const response = await axios.get(
                    `${config.API_URL}/OM/OrderStatus/${UM_CompanyID}`
                );

                // API returns { status: "Created" | "Approved", count }\
                console.log("orderstatus editingRowIndex", editingRowIndex, response.data.status)
                if (editingRowIndex !== null) {
                    setStatus(response.data.status);
                } else {
                    setStatus('Created');
                }
            } catch (error) {
                console.error('Error fetching order status:', error);
                setStatus(''); // fallback if needed
            }
        };

        if (UM_CompanyID) {
            fetchOrderStatus();
        }
    }, [UM_CompanyID]);

    const openPopup = () => {
        logAction(`Save As Order Template(): Started`)

        if (orderTableData.length == 0) {
            if (!selectedProductName) {
                document.getElementById('prdname').style.display = 'inline';
                document.getElementById('prdname').style.color = 'red';

            }
            if (!orderQuantity) {
                document.getElementById('ordq').style.display = 'inline';
                document.getElementById('ordq').style.color = 'red';
            }
            if (!selectedOrderType) {
                document.getElementById('ordtype').style.display = 'inline';
                document.getElementById('ordtype').style.color = 'red';
            }
            if (!selectedScpName) {
                document.getElementById('tscp').style.display = 'inline';
                document.getElementById('tscp').style.color = 'red';
            }

            if (!selectedProductName || !orderQuantity || !selectedorderType || !selectedScpName || !selectedfromScpName) {
                return;
            }

            if (orderTableData.length === 0) {
                toast.error("You need to add atleast one product to save as order template.");
                return;
            }


        }
        if (editingRowIndex != null) {
            document.getElementById('editingrowindex').style.display = 'inline';
            document.getElementById('editingrowindex').style.color = 'red';
            return;
        }


        const popupContent = `
<div id="popupOverlay" class="popup-overlay">
  <div id="popupContainer" class="popup">
    <h3 class="popup-title">Enter Template Name</h3>

    <div class="form-group">
      <label for="orderNameInput" class="label1">
        Template Name <span id="mySpan" style="display: none; color: red;">*</span>
      </label>

      <div class="input-wrapper">
        <input type="text" id="orderNameInput" class="form-input"  autoComplete="off" />
      </div>

      <!-- 👇 Error message displayed here -->
      <div id="nameError" class="error-text"></div>
    </div>

    <div class="popupbutton-container">
      <button id="submitButton" class="popupsave_btn">SAVE</button>
      <button id="backButton" class="popupback_btn">BACK</button>
    </div>
  </div>
</div>
`;

        // Create the popup dynamically
        const popupContainer = document.createElement('div');
        popupContainer.innerHTML = popupContent;
        document.body.appendChild(popupContainer);

        const orderNameInput = document.getElementById('orderNameInput');
        const mySpan = document.getElementById('mySpan');
        let userInteracted = false;
        const nameError = document.getElementById('nameError');
        // 🔹 Input validation and cleanup
        // ✅ Live cleaner while typing
        orderNameInput.addEventListener('input', (e) => {
            userInteracted = true;
            let value = e.target.value;

            // 1️⃣ Allow only letters, digits, spaces, dots, underscores, hyphens
            value = value.replace(/[^A-Za-z0-9\s._-]/g, '');

            // 2️⃣ Remove leading spaces or leading special characters
            value = value.replace(/^[\s._-]+/, '');

            // 3️⃣ Prevent consecutive spaces
            value = value.replace(/\s{2,}/g, ' ');

            // 4️⃣ Prevent consecutive special characters like "..", "__", "--", "._", etc.
            value = value.replace(/([._-]){2,}/g, '$1');

            // 5️⃣ Prevent space + special or special + space combos like " .", " -"
            value = value.replace(/\s+([._-])/g, '$1'); // remove space before special
            value = value.replace(/([._-])\s+/g, '$1'); // remove space after special

            // 6️⃣ Limit to 45 characters
            if (value.length > 45) {
                value = value.slice(0, 45);

            }

            // 👉 Live last-character validation
            const lastChar = value.charAt(value.length - 1);
            const alphanumericRegex = /^[a-zA-Z0-9]$/;

            if (lastChar && !alphanumericRegex.test(lastChar)) {
                nameError.style.display = "block";
                nameError.textContent = "First and last character must be alphanumeric";
            } else {
                nameError.style.display = "none";
                nameError.textContent = "";
            }


            // ✅ Do NOT remove trailing dot/hyphen here — allow while typing
            e.target.value = value;

            // 7️⃣ Hide required * when something valid exists
            if (value.trim() !== '') {
                mySpan.style.display = 'none';
            }
        });




        // 🔹 Submit button logic
        const submitButton = document.getElementById('submitButton');
        submitButton.addEventListener('click', async () => {
            const templateName = orderNameInput.value.trim();


            // Reset any old error
            nameError.style.display = 'none';
            nameError.textContent = '';

            // 🟥 Empty check
            if (templateName === '') {
                mySpan.style.display = 'inline';
                mySpan.style.color = 'red';
                nameError.style.display = 'block';

                return;
            }

            // 🧩 Check last character before blur cleanup
            const rawValue = orderNameInput.value; // value as user typed
            const lastCharRaw = rawValue.charAt(rawValue.length - 1);
            const alphanumericRegex = /^[a-zA-Z0-9]$/;

            if (!alphanumericRegex.test(lastCharRaw)) {
                nameError.style.display = 'block';
                nameError.textContent = 'First and last character must be alphanumeric';
                return;
            }

            // 🚫 Invalid special characters check
            const invalidSpecial = /[^A-Za-z0-9\s._-]/;
            if (invalidSpecial.test(templateName)) {
                nameError.style.display = 'block';
                nameError.textContent = 'Only letters, numbers, spaces, "-", "_", and "." are allowed';
                return;
            }

            // ✅ All good — hide errors
            nameError.style.display = 'none';
            mySpan.style.display = 'none';
            // Close the popup
            const fetchData = async () => {
                try {
                    const response = await axios.post(`${config.API_URL}/OM/ordertemplatelist`, {
                        ORTL_TemplateName: templateName,
                        selectedScpId: UM_UserId
                    });
                    // Update the state with the fetched data


                    setTemplateData(response.data);
                    //   console.log(response.data)
                    let length = response.data.length

                    if (response.data.length > 0) {
                        // Template name ______ already exists please choose another template name
                        toast.error(`Order Template : ${templateName} already exists.`)
                        return (<></>)
                    } else {
                        try {
                            for (const item of orderTableData) {
                                const scpName = item.SCPName;
                                const selectedScp = filteredScpNames.find(scp => scp.SCPM_Name === selectedScpName);
                                console.log("selectedScp", selectedScpName, item)
                                const SCP_ID = selectedScp ? selectedScp.SCPM_ID : null;
                                const productName = item.ProductName;

                                const orderMasterData = {
                                    ORTL_SCPIDFrom: selectedScpId,
                                    ORTL_SCPIDTo: selectedScpName, // Use SCPName from latest order
                                    ORTL_TemplateName: templateName,
                                    ORTL_ProductID: productName, // Use ProductName from latest order
                                    ORTL_OrderQty: parseFloat(item.OrderQuantity), // Use OrderQuantity from latest order
                                    ORTL_CreatedBy: UM_UserId
                                };
                                // Send data to ordermaster endpoint
                                const responseOrderMaster = await fetch(`${config.API_URL}/OM/saveordertemplate`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(orderMasterData),
                                });
                                if (!responseOrderMaster.ok) {
                                    throw new Error(
                                        `Error saving OrderTemplate data for SCP Name: ${scpName} and Product Name: ${productName}`
                                    );
                                }
                                const responseDataOrderMaster = await responseOrderMaster.json();


                            }
                            logAction(`Save As Order Template(): ${templateName} Templated Added`)
                            logAction(`Save As Order Template(): Ended`)

                            toast.success(`Order Template : ${templateName} saved successfully.`)
                            popupContainer.remove();
                            handleReset();

                        } catch (error) {
                            console.error('Error handling save:', error);
                        }
                    }
                } catch (error) {
                    // Handle errors if any
                    console.error('Error fetching data:', error);
                }
            };
            // Call the fetch data function when component mounts
            fetchData();
            // Call the API to save the data
        });
        // Attach event listener to the back button in the popup
        const backButton = document.getElementById('backButton');
        backButton.addEventListener('click', () => {
            logAction(`Save As Order Template(): Ended`)
            // Close the popup
            popupContainer.remove();
        });

    };

    const [companyCode, setCompanyCode] = useState(null);
    useEffect(() => {
        const fetchCompanyCode = async () => {
            try {
                const response = await fetch(`${config.API_URL}/OM/companycode/${UM_CompanyID}`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText}`);
                }
                const data = await response.json();

                setCompanyCode(data.CM_CompanyCode);
            } catch (err) {
                // setError(err.message);
                console.error(err)
            }
        };

        fetchCompanyCode();
    }, [UM_CompanyID]);

    const ordnumgen = async (data) => {


        try {
            let response;

            if (parseInt(BYSCP) === 1) {
                // 🧩 Case 1: When BYSCP = 1
                response = await axios.post(
                    `${config.API_URL}/OM/api/ordernumbergenerate`,
                    data
                );
            } else {
                // 🧩 Case 2: When BYSCP ≠ 1
                response = await axios.post(
                    `${config.API_URL}/OM/omso/ordernumbergenerate`,
                    { companycode: companyCode }
                );
            }

            if (response?.data) {
                const ordnum = response.data.newOrderNumber;

                setord(ordnum); // Assuming setord is your state setter
            } else {
                console.warn("⚠️ No order number received in response");
            }
        } catch (error) {
            console.error("❌ Error fetching order number:", error);

        } finally {
            // If you use a loading indicator, handle cleanup here
            // setIsSaving(false);
        }
    };

    const [totalPackSize, setTotalPackSize] = useState('');

    const handleProductNameChange = (e) => {
        const selectedValue = e.target.value;  // Get selected value (product name)

        setSelectedProductName(selectedValue);

        const name = filteredProductNames.find(p => p.PL_ProductName === selectedValue);
        const product = availableQuantity.find(p => p.PL_ProductName === selectedValue);

        // If found, read values safely
        setproductcode(name?.PL_ProductCode ?? "");
        setproductid(name?.PL_ProductId ?? "");

        // Set pack size safely
        setTotalPackSize(product?.totalPackSize ?? 0);

        document.getElementById('prdname').style.display = 'none';

        logAction(`HandleProductName Change (): ${selectedValue}`);
    };

    const usePopup = async () => {
        logAction('Use Order Template():Started');

        try {
            const response = await fetch(`${config.API_URL}/OM/Use_Order_Template_Name/${selectedScpId}`);
            if (!response.ok) throw new Error('Failed to fetch template data');

            let id = await response.json();

            if (id === "No") {
                toast.error("No template available");
                return;
            }

            const templateData = await id;
            if (templateData.length === 0) return;

            // ------------------ POPUP HTML ------------------
            const popupContent = `
      <div class="popup_overlay">
        <div class="popup">
          <img src="${x}" id="closePopupIcon"
              style="position:absolute; top:14px; right:22px; width:22px; height:22px; cursor:pointer;" />

          <h3 class="mb-4">Select Template</h3>

          <table class="tableClass">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Template Name</th>
                <th>To</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody id="template-table-body"></tbody>
          </table>

          <div id="pagination-controls" class="mt-3"></div>
        </div>
      </div>
    `;

            const popupContainer = document.createElement('div');
            popupContainer.innerHTML = popupContent;
            document.body.appendChild(popupContainer);

            // ------------------ CLOSE POPUP ------------------
            popupContainer.querySelector('#closePopupIcon')
                .addEventListener('click', () => {
                    logAction('Use Order Template():Closed via X icon');
                    popupContainer.remove();
                    document.body.classList.remove('blur-background');
                });

            let currentPage = 1;
            const rowsPerPage = 5;

            // ------------------ TABLE RENDER ------------------
            const renderTablePage = (page) => {
                const start = (page - 1) * rowsPerPage;
                const end = start + rowsPerPage;
                const paginatedData = templateData.slice(start, end);

                const tableBody = popupContainer.querySelector("#template-table-body");

                tableBody.innerHTML = paginatedData.map((template, index) => `
                <tr>
                    <td>${start + index + 1}</td>
                    <td>${template.ORTL_TemplateName}</td>
                    <td>${template.SCPM_Name}</td>

                    <td style="position: relative;">
                        <div class="addIcon" data-template-index="${start + index}"  title="Add"
                             style="cursor:pointer; display:inline-block;"></div>

                        <img src="${viewIcon}" class="eye-icon"  title="View"
                             data-template-index="${start + index}"
                              style="cursor: pointer; width: 20px; height: 20px; margin-left: 7px;"  />
                    </td>
                </tr>
            `).join('');

                // ------------------ REACT PLUS ICON RENDER ------------------
                const addIcons = popupContainer.querySelectorAll(".addIcon");

                addIcons.forEach(div => {
                    const root = ReactDOM.createRoot(div);
                    root.render(<FaPlus size={18} color="#9b9b9b" />);

                });

                attachEventListeners();
                renderPagination();
            };

            // ------------------ PAGINATION ------------------
            const renderPagination = () => {
                const totalPages = Math.ceil(templateData.length / rowsPerPage);
                const paginationContainer = popupContainer.querySelector("#pagination-controls");

                paginationContainer.innerHTML = '';

                const ul = document.createElement('ul');
                ul.className = 'pagination mt-3';

                const createPageItem = (label, page, disabled = false, active = false) => {
                    const li = document.createElement('li');
                    li.className = `page-item ${disabled ? 'disabled' : ''} ${active ? 'active' : ''}`;

                    const button = document.createElement('button');
                    button.className = 'page-linkd';
                    button.innerText = label;

                    if (!disabled) {
                        button.addEventListener('click', () => {
                            currentPage = page;
                            renderTablePage(currentPage);
                        });
                    }

                    li.appendChild(button);
                    return li;
                };

                // First + Previous
                ul.appendChild(createPageItem("First", 1, currentPage === 1));
                ul.appendChild(createPageItem("Previous", currentPage - 1, currentPage === 1));

                // Numbered pages
                const maxPageButtons = 5;
                let startPage = Math.max(currentPage - Math.floor(maxPageButtons / 2), 1);
                let endPage = Math.min(startPage + maxPageButtons - 1, totalPages);

                if (endPage - startPage < maxPageButtons) {
                    startPage = Math.max(endPage - maxPageButtons + 1, 1);
                }

                for (let i = startPage; i <= endPage; i++) {
                    ul.appendChild(createPageItem(i, i, false, i === currentPage));
                }

                // Next + Last
                ul.appendChild(createPageItem("Next", currentPage + 1, currentPage === totalPages));
                ul.appendChild(createPageItem("Last", totalPages, currentPage === totalPages));

                paginationContainer.appendChild(ul);
            };

            // ------------------ EVENT LISTENERS ------------------
            const attachEventListeners = () => {
                // ⭐ ADD ICON CLICK
                popupContainer.querySelectorAll('.addIcon').forEach(icon => {
                    icon.addEventListener('click', (event) => {
                        const index = event.target.closest(".addIcon")?.getAttribute("data-template-index");
                        const selectedTemplate = templateData[index];

                        setselectedTemplate(selectedTemplate);

                        logAction(`Use Order Template():${selectedTemplate.ORTL_TemplateName} Selected`);
                        logAction(`Use Order Template():Ended`);

                        axios.post(`${config.API_URL}/OM/getordertemplatedetailsbyname`, selectedTemplate)
                            .then(async (response) => {
                                const resultData = response.data;

                                setSelectedScpName(resultData[0].SCP_To_Name);

                                const mappedData = resultData.map(item => ({
                                    OrderQuantity: item.Order_Quantity,
                                    ProductName: item.Product_Name,
                                    SCPName: item.SCP_To_Name,
                                    OrderType: selectedorderType,
                                    productcode: item.Product_Code,
                                    productid: item.ProductId
                                }));

                                setOrderTableData(mappedData);

                                // Fetch schemes etc...
                                const selectedScp = filteredScpNames.find(scp => scp.SCPM_Name === resultData[0].SCP_To_Name);
                                if (selectedScp) {
                                    const fetchedSchemes = await fetchSchemesForSCP(selectedScp.SCPM_ID, selectedScpId);

                                    if (fetchedSchemes.length > 0) {
                                        const eligibleSchemes = fetchedSchemes.filter(scheme =>
                                            isSchemeEligible(scheme, mappedData)
                                        );

                                        const enrichedSchemes = fetchedSchemes.map(scheme => ({
                                            ...scheme,
                                            isEligible: eligibleSchemes.some(
                                                el => String(el.SM_ID) === String(scheme.SM_ID)
                                            ),
                                        }));

                                        setSchemeData(enrichedSchemes);

                                        if (eligibleSchemes.length === 1) {
                                            handleApplyScheme(eligibleSchemes[0], { isAuto: true, orderData: mappedData });
                                            toast.success(`Scheme : ${eligibleSchemes[0].SM_SchemeName} applied successfully.`, { onClose: () => setIsSaving(false) });
                                        }
                                    }
                                }

                                setTemplateUse(true);
                                toast.success(`Order Template : ${selectedTemplate.ORTL_TemplateName} added successfully.`);
                            });

                        popupContainer.remove();
                        document.body.classList.remove("blur-background");
                    });
                });

                // 👁 VIEW ICON click
                popupContainer.querySelectorAll(".eye-icon").forEach(icon => {
                    icon.addEventListener("click", () => {
                        const index = icon.getAttribute("data-template-index");
                        const template = templateData[parseInt(index)];

                        const existing = document.getElementById("product-detail-popup");
                        if (existing) existing.remove();

                        const overlay = document.createElement("div");
                        overlay.id = "product-detail-popup";

                        overlay.style = `
                        position: fixed; inset: 0;
                        background: rgba(0,0,0,0.3);
                        z-index: 99998;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    `;

                        const popup = document.createElement("div");
                        popup.style = `
                        background: white;
                        padding: 20px;
                        border-radius: 8px;
                        max-height: 80%;
                        width: 500px;
                        overflow-y: auto;
                        position: relative;
                    `;

                        popup.innerHTML = `
                        <img src="${x}" id="close-product-popup"
                             style="position:absolute; top:10px; right:14px; width:22px; cursor:pointer;" />

                        <h5 style="margin-bottom:20px;">Product Details</h5>

                        <table class="tableClass">
                            <thead>
                                <tr><th>Product Name</th><th>Order Quantity</th></tr>
                            </thead>
                            <tbody>
                                ${template.products.map(p => `
                                    <tr><td>${p.productName}</td><td>${p.qty}</td></tr>
                                `).join('')}
                            </tbody>
                        </table>
                    `;

                        overlay.appendChild(popup);
                        document.body.appendChild(overlay);

                        document.getElementById("close-product-popup").addEventListener("click", () => {
                            overlay.remove();
                        });
                    });
                });
            };

            // INIT
            renderTablePage(currentPage);
            document.body.classList.add('blur-background');

        } catch (error) {
            console.error('Error fetching template data:', error);
        }
    };

    const handleRemove = (recordId) => {
        console.log("🗑️ handleRemove() called with recordId:", recordId);

        if (editingRowIndex == null) {
            console.log("✔ No row being edited → Proceed with removal");

            const updatedOrderTableData = orderTableData.filter((item, index) => {
                const match = index !== recordId;
                console.log(` - Filtering index ${index}, keep: ${match}`);
                return match;
            });

            console.log("📌 Updated Order Table Data:", updatedOrderTableData);

            logAction(`HandleRemove(): Product Removed`);
            setOrderTableData(updatedOrderTableData);

            // If all items are removed, reset dropdowns
            if (orderTableData.length === 1) {
                console.log("🔄 All items removed → resetting dropdownKey");
                setDropdownKey(prevKey => prevKey + 1);
            }

            // 🧠 Recheck offer eligibility
            if (offersFetched && schemes.length > 0) {
                console.log("🎯 Rechecking offer eligibility...");

                const eligibleSchemes = schemes.filter((scheme) =>
                    isSchemeEligible(scheme, updatedOrderTableData)
                );
                console.log("   → Eligible Schemes:", eligibleSchemes);

                // Add eligibility
                const enrichedSchemes = schemes.map((scheme) => ({
                    ...scheme,
                    isEligible: eligibleSchemes.some(
                        (el) => String(el.SM_ID) === String(scheme.SM_ID)
                    ),
                }));

                console.log("   → Enriched Schemes:", enrichedSchemes);
                setSchemeData(enrichedSchemes);

                // If applied scheme is no longer eligible
                if (
                    selectedSchemeId &&
                    !eligibleSchemes.some((el) => String(el.SM_ID) === String(selectedSchemeId))
                ) {
                    console.log("❌ Applied scheme no longer eligible → clearing");
                    setSelectedSchemeId(null);
                    setAppliedSchemes({});
                }

                // Multiline eligible case
                if (eligibleSchemes.length > 1) {
                    console.log("ℹ Multiple eligible schemes remain");
                }

                // Only one eligible scheme → auto apply
                if (eligibleSchemes.length === 1) {
                    const singleScheme = eligibleSchemes[0];
                    console.log("🟢 Auto applying single eligible scheme:", singleScheme);

                    handleApplyScheme(singleScheme, { isAuto: true, orderData: updatedOrderTableData });
                    toast.success(`Scheme : ${singleScheme.SM_SchemeName} applied successfully.`, { onClose: () => setIsSaving(false) });
                }

                // Build ticker messages
                const newTickerMessages = [];
                console.log("📢 Building new ticker messages…");

                enrichedSchemes.forEach((scheme) => {
                    if (!scheme.requiredProducts) return;

                    const related = scheme.requiredProducts.some((req) =>
                        updatedOrderTableData.some(
                            (item) =>
                                String(item.productid) === String(req.SPM_ProductID) ||
                                String(item.ProductName) === String(req.ProductName) ||
                                String(item.ProductName) === String(req.PL_ProductName)
                        )
                    );

                    if (!related) {
                        console.log(`   - Scheme ${scheme.SM_SchemeName} not related to remaining products`);
                        return;
                    }

                    const missingParts = scheme.requiredProducts
                        .map((req) => {
                            const ordered = updatedOrderTableData.find(
                                (item) =>
                                    String(item.productid) === String(req.SPM_ProductID) ||
                                    String(item.ProductName) === String(req.ProductName) ||
                                    String(item.ProductName) === String(req.PL_ProductName)
                            );
                            const orderedQty = parseFloat(ordered?.OrderQuantity || 0);
                            const requiredQty = parseFloat(req?.SPM_Quantity || 0);
                            const diff = requiredQty - orderedQty;

                            const prodName =
                                req.ProductName ||
                                req.PL_ProductName ||
                                req.Product_Name ||
                                req.productname ||
                                req.SPM_ProductName ||
                                "this product";

                            if (diff > 0) {
                                const msg = `Add ${diff} more ${diff === 1 ? "quantity" : "quantities"} of ${prodName}`;
                                console.log(`   → Missing part: ${msg}`);
                                return msg;
                            }
                            return null;
                        })
                        .filter(Boolean);

                    if (missingParts.length > 0) {
                        const tickerMsg = `${missingParts.join(" and ")} to avail offer ${scheme.SM_SchemeName}`;
                        console.log("   → Adding ticker:", tickerMsg);
                        newTickerMessages.push(tickerMsg);
                    }
                });

                console.log("📢 Final Ticker Messages:", newTickerMessages);
                setTickerMessages(newTickerMessages);
            }

            // Table empty → clear ticker
            if (updatedOrderTableData.length === 0) {
                console.log("🧹 Table empty → clearing ticker messages");
                setTickerMessages([]);
            }

        } else {
            console.log("✏ Ending edit mode for row:", editingRowIndex);
            logAction(`HandleEdit(): Ended`);
            setEditingRowIndex(null);
            setDropdownKey(prevKey => prevKey + 1);
        }

        console.log("✅ handleRemove() completed");
    };

    const audittrailpost = async (details) => {
        const getCurrentTimestamp = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const currentTimestamp = getCurrentTimestamp();
        const AUTR_OldValue = details?.AUTR_OldValue ?? null;
        const AUTR_NewValue = details?.AUTR_NewValue ?? null;
        const AUTR_Message = details.AUTR_Message;
        const AUTR_AuditType = details.AUTR_AuditType;
        if (UM_CompanyID === null || UM_CompanyID === "null" || UM_CompanyGrpID === null || UM_CompanyGrpID === "null" || selectedScpId === null || selectedScpId === "null") {

            const data = {
                AUTR_ScreenName: "Order Master by SCP",
                AUTR_OldValue: AUTR_OldValue,
                AUTR_NewValue: AUTR_NewValue,
                AUTR_Message: AUTR_Message,
                AUTR_UserID: UM_UserId,
                AUTR_UserName: UM_UserCode,
                AUTR_TimeStamp: currentTimestamp,
                AUTR_AuditType: AUTR_AuditType,
                AUTR_SCPID: null,
                AUTR_CompanyGrpId: null,
                AUTR_CompanyID: null,
                AUTR_CreatedBy: UM_UserId,
                AUTR_CreatedDateTime: currentTimestamp
            };

            try {
                const response = await axios.post(`${config.API_URL}/api/audittrail`, data);

                return response.data;
            } catch (error) {
                console.error('Error:', error);
            }
        } else {

            const data = {
                AUTR_ScreenName: "Order Master by SCP",
                AUTR_OldValue: AUTR_OldValue,
                AUTR_NewValue: AUTR_NewValue,
                AUTR_Message: AUTR_Message,
                AUTR_UserID: UM_UserId,
                AUTR_UserName: UM_UserCode,
                AUTR_TimeStamp: currentTimestamp,
                AUTR_AuditType: AUTR_AuditType,
                AUTR_SCPID: selectedScpId,
                AUTR_CompanyGrpId: UM_CompanyID,
                AUTR_CompanyID: UM_CompanyID,
                AUTR_CreatedBy: UM_UserId,
                AUTR_CreatedDateTime: currentTimestamp
            };

            try {
                const response = await axios.post(`${config.API_URL}/api/audittrail`, data);

                return response.data;
            } catch (error) {
                console.error('Error:', error);
            }
        }

    };

    const audittransaction = async (data) => {
        const formData = {
            AUTRN_ID: data.AUTRN_ID,
            AUTRN_OldValue: data.AUTRN_OldValue ?? null,
            AUTRN_NewValue: data.AUTRN_NewValue,
            AUTRN_ParamererName: data.AUTRN_ParamererName
        };

        try {
            const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
            // alert('Data inserted successfully');
        } catch (error) {
            if (error.response) {
                // Server responded with a status other than 2xx
                console.error('Server responded with an error:', error.response.data);
                // alert(`Error: ${error.response.status} - ${error.response.data}`);
            } else if (error.request) {
                // No response received from server
                console.error('No response received:', error.request);
                // alert('Error: No response received from server');
            } else {
                // Other errors
                console.error('Error setting up the request:', error.message);
                // alert('Error: Request setup failed');
            }
        }
    }
    useEffect(() => {


        fetch(`${config.API_URL}/OM/fetchScpDetails/${selectedScpId}`)
            .then(response => response.json())
            .then(data => {

                if (data && data.SCPM_Name) {
                    setcreatedbyscp(data.SCPM_ID)
                    setSelectedfromScpName(data.SCPM_Name);
                    setselectedfromScpLevelNo(data.SCPM_LevelNo);
                }
            })
            .catch(error => console.error('Error fetching SCP details:', error));
    }, [selectedScpId, BYSCP]);

    useEffect(() => {


        fetch(`${config.API_URL}/OM/ToSCP/${selectedScpId}`)
            .then(response => response.json())
            .then(data => {
                // Extract the SCPs array from the response
                const SCPs = data.SCPs;

                const sortedSCPs = [...data.SCPs].sort((a, b) => b.SCPM_ID - a.SCPM_ID);

                // Create a new array to store SCP names
                const scpNamesArray = sortedSCPs.map(scp => scp.SCPM_Name);

                setScpOptions(scpNamesArray);

                // Set the filtered SCP names state with the SCP names array

                setFilteredScpNames(sortedSCPs);
                setscpNames(sortedSCPs);
            })
            .catch(error => console.error('Error fetching SCP names:', error));
        // Fetch product names from the server


        fetch(`${config.API_URL}/OM/ProductList/${UM_CompanyID}`)
            .then(response => response.json())
            .then(data => {

                // setProductNames(data.PL_ProductName);
                // setFilteredProductNames(data.PL_ProductName);
                setavailableQuantity(data.PL_ProductName);
            })
            .catch(error => console.error('Error fetching product names:', error));
        fetch(`${config.API_URL}/OM/productnames/${UM_CompanyID}`)
            .then(response => response.json())
            .then(data => {

                setProductNames(data.PL_ProductName);
                setFilteredProductNames(data.PL_ProductName);
                // setavailableQuantity(data);
            })
            .catch(error => console.error('Error fetching product names:', error));
    }, [selectedScpId]);

    useEffect(() => {
        const fetchOrderTypes = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/OM/orderTypes`);

                setOrderType(response.data);
            } catch (error) {
                console.error('Error fetching order types:', error);
            }
        };
        fetchOrderTypes();
    }, []);

    useEffect(() => {
        // Check if orderTableData is empty
        if (orderTableData.length === 0) {
            // Enable the dropdown
            setIsToDropdownDisabled(false);
        } else {
            // Disable the dropdown
            setIsToDropdownDisabled(true);
        }
    }, [orderTableData]);

    const isSchemeEligible = (scheme, orderTableData) => {
        if (!scheme?.requiredProducts || !Array.isArray(orderTableData)) return false;

        const { SM_IsCombinationRequired } = scheme;

        if (SM_IsCombinationRequired === 1) {
            // ✅ Combination required (AND logic)

            return scheme.requiredProducts.every((sp) => {
                const ordered = orderTableData.find(
                    (od) => parseInt(od.productid) === parseInt(sp.SPM_ProductID)
                );
                return (
                    ordered &&
                    parseFloat(ordered.OrderQuantity) >= parseFloat(sp.SPM_Quantity)
                );
            });
        } else {
            // ✅ Combination NOT required (OR logic)
            // Must meet quantity for ANY ONE of required products
            return scheme.requiredProducts.some((sp) => {
                const ordered = orderTableData.find(
                    (od) => parseInt(od.productid) === parseInt(sp.SPM_ProductID)
                );
                return (
                    ordered &&
                    parseFloat(ordered.OrderQuantity) >= parseFloat(sp.SPM_Quantity)
                );
            });
        }
    };

    const handleOrderSubmit = async () => {

        logAction("Handle Order Submit(): Started");

        const updatedOrderTableData = [...orderTableData];


        if (!selectedProductName) {
            document.getElementById('prdname').style.display = 'inline';
            document.getElementById('prdname').style.color = 'red';
        }
        if (!orderQuantity) {
            document.getElementById('ordq').style.display = 'inline';
            document.getElementById('ordq').style.color = 'red';
        }
        if (!selectedorderType) {
            document.getElementById('ordtype').style.display = 'inline';
            document.getElementById('ordtype').style.color = 'red';
        }
        if (!selectedScpName) {
            document.getElementById('tscp').style.display = 'inline';
            document.getElementById('tscp').style.color = 'red';
        }

        if (parseInt(BYSCP) === 0) {

            if (!selectedFromScp) {
                document.getElementById('fscp').style.display = 'inline'
                document.getElementById('fscp').style.color = 'red'
            }
        }

        // If any of the above fields are missing, stop execution
        if (!selectedProductName || !orderQuantity || !selectedorderType || !selectedScpName) {
            return;
        }
        ordnumgen(data);



        if (isQuantityvalid) return;

        // 🧱 Build new order item
        const newOrderItem = {
            SCPName: selectedScpName,
            ProductName: selectedProductName,
            OrderQuantity: parseFloat(orderQuantity),
            OrderType: selectedOrderType,
            productcode,
            productid,
        };

        // 🧩 Create temp table representing state AFTER adding product
        let tempOrderTableData;
        const existingProductIndex = orderTableData.findIndex(
            (item) => item.ProductName === selectedProductName
        );

        if (existingProductIndex !== -1) {
            tempOrderTableData = [...orderTableData];
            tempOrderTableData[existingProductIndex] = {
                ...tempOrderTableData[existingProductIndex],
                OrderQuantity:
                    Number(tempOrderTableData[existingProductIndex].OrderQuantity || 0) +
                    Number(orderQuantity || 0),
            };
        } else {
            tempOrderTableData = [...orderTableData, newOrderItem];
        }

        // 🎯 Scheme logic
        if (offersFetched && schemes.length > 0) {
            // ✅ Use tempOrderTableData (includes newly added product)
            const eligibleSchemes = schemes.filter((scheme) =>
                isSchemeEligible(scheme, tempOrderTableData)
            );

            // 🏷️ Enrich all schemes with eligibility info
            const enrichedSchemes = schemes.map((scheme) => ({
                ...scheme,
                isEligible: eligibleSchemes.some(
                    (el) => String(el.SM_ID) === String(scheme.SM_ID)
                ),
            }));

            // Update the scheme data state
            setSchemeData(enrichedSchemes);

            // 🟡 Build ticker messages for related schemes
            const newTickerMessages = [];


            enrichedSchemes.forEach((scheme) => {
                if (!scheme.requiredProducts) return;

                // Check if scheme is related to any product in the order
                const related = scheme.requiredProducts.some((req) =>
                    tempOrderTableData.some(
                        (item) =>
                            String(item.productid) === String(req.SPM_ProductID) ||
                            String(item.ProductName) === String(req.ProductName) ||
                            String(item.ProductName) === String(req.PL_ProductName)
                    )
                );
                if (!related) return; // skip unrelated schemes


                //             // Find how much quantity is missing
                //         const missingParts = scheme.requiredProducts
                // .map((req) => {
                //     const ordered = tempOrderTableData.find(
                //         (item) =>
                //             String(item.productid) === String(req.SPM_ProductID) ||
                //             String(item.ProductName) === String(req.ProductName) ||
                //             String(item.ProductName) === String(req.PL_ProductName)
                //     );

                //     const orderedQty = parseFloat(ordered?.OrderQuantity || 0);
                //     const requiredQty = parseFloat(req?.SPM_Quantity || 0);
                //     const diff = requiredQty - orderedQty;
                //     const ProductName = ordered?.ProductName;

                //     const prodName =
                //         ProductName ||
                //         req.PL_ProductName ||
                //         req.Product_Name ||
                //         req.productname ||
                //         req.SPM_ProductName ||
                //         "this product";

                //     return diff > 0 ? `Add ${diff} more quantities of ${prodName}` : null;
                // })
                // .filter(Boolean);


                const isCombination = parseInt(scheme.SM_IsCombinationRequired) === 1;

                let missingParts = [];

                // ✅ Get all required product details
                const productDiffs = scheme.requiredProducts.map((req) => {
                    const ordered = tempOrderTableData.find(
                        (item) =>
                            String(item.productid) === String(req.SPM_ProductID) ||
                            String(item.ProductName) === String(req.ProductName) ||
                            String(item.ProductName) === String(req.PL_ProductName)
                    );

                    const orderedQty = parseFloat(ordered?.OrderQuantity || 0);
                    const requiredQty = parseFloat(req?.SPM_Quantity || 0);
                    const diff = requiredQty - orderedQty;
                    const progressPercent = requiredQty > 0 ? (orderedQty / requiredQty) * 100 : 0;

                    const prodName =
                        ordered?.ProductName ||
                        req.PL_ProductName ||
                        req.Product_Name ||
                        req.productname ||
                        req.SPM_ProductName ||
                        "this product";

                    return { prodName, diff, progressPercent, orderedQty, requiredQty };
                });

                if (isCombination) {
                    // Check if ANY required product crossed 40%
                    const anyCrossed40 = productDiffs.some(
                        (p) => p.progressPercent >= 40
                    );

                    if (anyCrossed40) {
                        missingParts = productDiffs
                            .filter((p) => p.diff > 0)
                            .map((p) => {
                                const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
                                return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
                            });
                    }
                }
                else {
                    // ✅ Normal OR logic: show only for 40%+ products
                    missingParts = productDiffs
                        .filter((p) => p.progressPercent >= 40 && p.diff > 0)
                        .map((p) => {
                            const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
                            return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
                        });
                }




                if (missingParts.length > 0) {
                    newTickerMessages.push(
                        ` ${missingParts.join(" and ")} to avail ${scheme.SM_SchemeName} Offer`
                    );
                }
            });

            // ✅ Update ticker messages state
            setTickerMessages(newTickerMessages);

            if (selectedSchemeId) {
                const stillEligible = eligibleSchemes.some(
                    (scheme) => String(scheme.SM_ID) === String(selectedSchemeId)
                );

                if (!stillEligible) {
                    const removedScheme = schemes.find(
                        (s) => s.SM_ID === selectedSchemeId
                    );
                    setSelectedSchemeId(null);
                    setAppliedSchemes({});

                } else {
                    // === NEW: recompute free quantities for the already-selected scheme ===
                    const selScheme = schemes.find(s => String(s.SM_ID) === String(selectedSchemeId));
                    if (selScheme) {
                        const newApplied = computeAppliedSchemeObject(selScheme, tempOrderTableData);
                        // update applied scheme in state (keep same key)
                        setAppliedSchemes({ [selScheme.SM_ID]: newApplied });
                        // optional: keep selectedSchemeId unchanged
                    }
                }
            }


            // 🟢 Auto-apply if only one scheme is eligible
            if (!selectedSchemeId && eligibleSchemes.length === 1) {
                handleApplyScheme(eligibleSchemes[0], { isAuto: true, orderData: tempOrderTableData });
                toast.success(`Scheme : ${eligibleSchemes[0].SM_SchemeName} applied successfully.`, { onClose: () => setIsSaving(false) });
            }

            // ⚠️ Multiple eligible → let user choose
            if (eligibleSchemes.length > 1) {
                setSelectedSchemeId(null);
                setAppliedSchemes({});
                setSchemeData(enrichedSchemes);

                toast.success("Multiple offers are applicable. Please choose the offer that benefits you the most.");

            }

            // ❌ None eligible
            if (eligibleSchemes.length === 0 && !selectedSchemeId) {
            }
        }

        // ✅ Commit the new item to real state
        if (existingProductIndex !== -1) {
            updatedOrderTableData[existingProductIndex].OrderQuantity =
                Number(updatedOrderTableData[existingProductIndex].OrderQuantity || 0) +
                Number(orderQuantity || 0);
            setOrderTableData(updatedOrderTableData);
        } else {
            setOrderTableData((prev) => [...prev, newOrderItem]);
        }

        // 🧹 Reset form fields
        setSelectedProductName("");
        setOrderQuantity("");
        setSelectedOrderType(selectedorderType);
        setIsToDropdownDisabled(true);
        setDropdownKeyprdname((prevKey) => prevKey + 1);
        setTotalPackSize("");

        logAction("Handle Order Submit(): Ended");
    };

    // Helper: compute applied scheme object (pure function)
    const computeAppliedSchemeObject = (scheme, orderData) => {
        if (!scheme) return null;

        const isCombination = scheme.SM_IsCombinationRequired === 1;

        const multipliers = (scheme.requiredProducts || []).map((req) => {
            const orderedProduct = (orderData || []).find(
                (item) =>
                    String(item.productid) === String(req.SPM_ProductID) ||
                    String(item.ProductName) === String(req.ProductName)
            );
            if (!orderedProduct) return 0;
            const buyQty = Number(req.SPM_Quantity || 0);
            if (!buyQty) return 0;
            const orderedQty = Number(orderedProduct.OrderQuantity || 0);
            return Math.floor(orderedQty / buyQty);
        });

        let multiplier = 0;
        if (multipliers.length > 0) {
            multiplier = isCombination
                ? Math.min(...multipliers.filter((m) => m > 0)) || 0
                : Math.max(...multipliers) || 0;
        }

        const appliedScheme = {
            discount: scheme.SM_Discount,
            giftArticle: null,
            freeProducts: [],
        };

        if (scheme.SM_GiftArticle) {
            appliedScheme.giftArticle = {
                name: scheme.SM_GiftArticle,
                quantity: (parseInt(scheme.SM_Quantity || 1) || 1) * multiplier,
            };
        }

        if (scheme.freeProducts?.length > 0) {
            appliedScheme.freeProducts = scheme.freeProducts.map((fp) => ({
                freeProductId: fp.SFPM_ProductID || fp.productid || fp.id,
                freeProductName: fp.PL_ProductName,
                freeQuantity: (parseInt(fp.SFPM_Quantity || 0) || 0) * multiplier,
                freeProductCode: fp.ProductCode,
            }));
        }

        return appliedScheme;
    };

    const handleChangeOrderQuantity = (e) => {
        //ordnumgen(data);
        const value = e.target.value;


        const regex = /^(?:[1-9][0-9]{0,10})?$/;

        if (regex.test(value)) {
            setOrderQuantity(value);

            // Handle empty
            if (value === "") {
                setisQuantityvalid(true);
                // document.getElementById("ordq").style.display = "inline";
                // document.getElementById("ordq").style.color = "red";
                return;
            }

            // Handle valid numeric input
            const numericValue = parseInt(value, 10);

            if (numericValue > 0) {
                setisQuantityvalid(false);
                seterrormsgOrderQuantity("");
                document.getElementById("ordq").style.display = "none";
            } else {
                setisQuantityvalid(true);
                seterrormsgOrderQuantity("Enter quantity greater than 0");
                document.getElementById("ordq").style.display = "inline";
                document.getElementById("ordq").style.color = "red";
            }
        } else {
            // ❌ Invalid input: starts with 0, non-numeric, or longer than 11 digits
            return; // Simply ignore invalid input
        }
    };

    const handleReset = () => {
        logAction(`HandleReset (): Started`);
        setEditingRowIndex(null);
        setSelectedSchemeId(null);
        setAppliedSchemes({});
        setOffersFetched(false);
        setSchemes([]);
        setSchemeData([]);
        setIsSchemeModalOpen(false);

        setSelectedScpName('');
        setSelectedProductName('');
        setOrderQuantity('');
        setOrderTableData([]);

        setIsResetMode(true);
        setOrderDate(new Date());
        setDropdownKey(prevKey => prevKey + 1);
        setDropdownKeyprdname(prevKey => prevKey + 1);
        setTotalPackSize('');
        setSelectedSchemeId(null);
        setAppliedSchemes({});

        // 👇 Reset dropdown
        setSelectedFromScp(null);

        if (orderTypes && orderTypes.length > 0 && orderTypes[0]?.EnumVal !== undefined) {
            setselectedorderType(orderTypes[0].EnumVal);
            logAction(`HandleReset (): Order Type reset to ${orderTypes[0].Description}`);
        }

        // 👇 Conditionally reset based on BYSCP
        if (BYSCP === 0) {
            setord("");
            document.getElementById('fscp').style.display = 'none';
            setSelectedfromScpName('');
            logAction(`HandleReset (): BYSCP is 0 → fromScpName cleared`);
        } else {
            logAction(`HandleReset (): BYSCP is not 0 → fromScpName preserved`);
        }

        // 👇 Hide DOM elements
        document.getElementById('ordtype').style.display = 'none';
        document.getElementById('tscp').style.display = 'none';

        document.getElementById('prdname').style.display = 'none';
        document.getElementById('ordq').style.display = 'none';

        seterrormsgOrderQuantity('');

        logAction(`HandleReset (): Page Reset Successfully`);
        logAction(`HandleReset (): Ended`);
    };

    const handleEditClick = (index) => {
        logAction(`HandleEdit (): Started`)
        setEditingRowIndex(index);
        setTempOrderQuantity(orderTableData[index].OrderQuantity);

        setTimeout(() => {
            inputRef.current.focus();
        }, 0.000001);
    };

    useEffect(() => {
        const table = document.querySelector(".table_container");
        if (table) {
            if (editingRowIndex !== null) table.classList.add("no-scroll");
            else table.classList.remove("no-scroll");
        }
    }, [editingRowIndex]);


    const handleSaveClick = () => {

        if (tempOrderQuantity === "" || tempOrderQuantity === null) {
            const input = document.getElementById("editingrowindexinput");
            if (input) {
                input.classList.add("input-error"); // Add red border or similar
            }
            toast.error("Please enter quantity.");
            return;
        }


        const updatedOrderTableData = [...orderTableData];



        if (!isNaN(tempOrderQuantity) && tempOrderQuantity > 0) {
            logAction(
                `HandleEdit (): ${updatedOrderTableData[editingRowIndex].ProductName} - ${updatedOrderTableData[editingRowIndex].OrderQuantity}: Old Value`
            );
            logAction(
                `HandleEdit (): ${updatedOrderTableData[editingRowIndex].ProductName} - ${tempOrderQuantity}: New Value`
            );
            logAction(`HandleEdit (): Ended`);

            updatedOrderTableData[editingRowIndex].OrderQuantity = tempOrderQuantity;
            setOrderTableData(updatedOrderTableData);
            setEditingRowIndex(null);

            // 🎯 Recalculate scheme eligibility after quantity change
            if (offersFetched && schemes.length > 0) {
                const eligibleSchemes = schemes.filter((scheme) =>
                    isSchemeEligible(scheme, updatedOrderTableData)
                );

                // 🏷️ Mark each scheme as eligible/ineligible
                const enrichedSchemes = schemes.map((scheme) => ({
                    ...scheme,
                    isEligible: eligibleSchemes.some(
                        (el) => String(el.SM_ID) === String(scheme.SM_ID)
                    ),
                }));

                // Update state before further logic
                setSchemeData(enrichedSchemes);

                // 🔁 Update free quantities for already-applied scheme
                if (selectedSchemeId && enrichedSchemes.length > 0) {
                    const applied = enrichedSchemes.find(
                        (s) => String(s.SM_ID) === String(selectedSchemeId)
                    );

                    if (applied && applied.requiredProducts) {
                        const isCombination = applied.SM_IsCombinationRequired === 1;
                        const multipliers = applied.requiredProducts.map((req) => {
                            const orderedProduct = updatedOrderTableData.find(
                                (item) => String(item.productid) === String(req.SPM_ProductID)
                            );
                            if (!orderedProduct) return 0;
                            const buyQty = Number(req.SPM_Quantity || 0);
                            const orderedQty = Number(orderedProduct.OrderQuantity || 0);
                            return Math.floor(orderedQty / buyQty);
                        });

                        let multiplier = 0;
                        if (multipliers.length > 0) {
                            multiplier = isCombination
                                ? Math.min(...multipliers.filter((m) => m > 0)) || 0
                                : Math.max(...multipliers) || 0;
                        }

                        const fullScheme = schemes.find(
                            (s) => String(s.SM_ID) === String(selectedSchemeId)
                        );

                        const updatedFreeProducts = (fullScheme?.freeProducts || []).map((fp) => ({
                            freeProductId: fp.SFPM_ProductID || fp.productid || fp.id,
                            freeProductName: fp.PL_ProductName || fp.freeProductName || "",
                            freeProductCode: fp.ProductCode || fp.freeProductCode || "",
                            freeQuantity:
                                (parseInt(fp.SFPM_Quantity || fp.freeQuantity || 0) || 0) *
                                multiplier,
                        }));

                        const updatedGiftArticle = fullScheme?.SM_GiftArticle
                            ? {
                                name: fullScheme.SM_GiftArticle,
                                quantity:
                                    (parseInt(fullScheme.SM_Quantity || 1) || 1) * multiplier,
                            }
                            : null;

                        setAppliedSchemes({
                            [selectedSchemeId]: {
                                discount: fullScheme?.SM_Discount,
                                giftArticle: updatedGiftArticle,
                                freeProducts: updatedFreeProducts,
                            },
                        });
                    }
                }

                // 🧠 Remove scheme if invalid now
                if (selectedSchemeId) {
                    const stillEligible = eligibleSchemes.some(
                        (scheme) => String(scheme.SM_ID) === String(selectedSchemeId)
                    );
                    if (!stillEligible) {
                        setSelectedSchemeId(null);
                        setAppliedSchemes({});
                    }
                }

                // 🟢 Auto-apply if only one scheme eligible
                if (!selectedSchemeId && eligibleSchemes.length === 1) {
                    handleApplyScheme(eligibleSchemes[0], { isAuto: true });
                    toast.success(
                        `Scheme : ${eligibleSchemes[0].SM_SchemeName} applied successfully.`, { onClose: () => setIsSaving(false) }
                    );
                }

                // ⚠️ Multiple eligible → open modal
                if (!selectedSchemeId && eligibleSchemes.length > 1) {
                    setSelectedSchemeId(null);
                    setAppliedSchemes({});
                    setSchemeData(enrichedSchemes);
                    toast.success("Multiple offers are applicable. Please choose the offer that benefits you the most.");

                }

                //  Recalculate ticker messages
                const newTickerMessages = [];

                enrichedSchemes.forEach((scheme) => {
                    if (!scheme.requiredProducts) return;

                    const related = scheme.requiredProducts.some((req) =>
                        updatedOrderTableData.some(
                            (item) =>
                                String(item.productid) === String(req.SPM_ProductID) ||
                                String(item.ProductName) === String(req.ProductName) ||
                                String(item.ProductName) === String(req.PL_ProductName)
                        )
                    );
                    if (!related) return;


                    const isCombination = parseInt(scheme.SM_IsCombinationRequired) === 1;

                    let missingParts = [];

                    // ✅ Get all required product details
                    const productDiffs = scheme.requiredProducts.map((req) => {
                        const ordered = updatedOrderTableData.find(
                            (item) =>
                                String(item.productid) === String(req.SPM_ProductID) ||
                                String(item.ProductName) === String(req.ProductName) ||
                                String(item.ProductName) === String(req.PL_ProductName)
                        );

                        const orderedQty = parseFloat(ordered?.OrderQuantity || 0);
                        const requiredQty = parseFloat(req?.SPM_Quantity || 0);
                        const diff = requiredQty - orderedQty;
                        const progressPercent = requiredQty > 0 ? (orderedQty / requiredQty) * 100 : 0;

                        const prodName =
                            ordered?.ProductName ||
                            req.PL_ProductName ||
                            req.Product_Name ||
                            req.productname ||
                            req.SPM_ProductName ||
                            "this product";

                        return {
                            productid: req.SPM_ProductID,
                            prodName,
                            diff,
                            progressPercent,
                            orderedQty,
                            requiredQty,
                        };
                    });

                    if (isCombination) {
                        // ✅ Check if any product in combination has reached 40–99%
                        const partiallyProgressed = productDiffs.some(
                            (p) => p.progressPercent >= 40
                        );

                        if (partiallyProgressed) {
                            missingParts = productDiffs
                                .filter((p) => p.diff > 0)
                                .map((p) => {
                                    const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
                                    return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
                                });


                        } else {

                        }
                    }
                    else {
                        // ✅ Normal OR logic: show only for 40%+ products
                        missingParts = productDiffs
                            .filter((p) => p.progressPercent >= 40 && p.diff > 0)
                            .map((p) => {
                                const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
                                return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
                            });
                    }



                    if (missingParts.length > 0) {
                        newTickerMessages.push(
                            ` ${missingParts.join(" and ")} to avail ${scheme.SM_SchemeName} Offer`
                        );
                    }
                });

                // ✅ Update ticker messages state
                setTickerMessages(newTickerMessages);
            }
        }
    };

    const handleInputChange = (e) => {
        let value = e.target.value;

        // Allow only digits
        value = value.replace(/\D/g, "");

        // Block leading zeros
        value = value.replace(/^0+/, "");

        // Limit to 11 digits
        if (value.length > 11) {
            value = value.slice(0, 11);
        }

        setTempOrderQuantity(value);
    };

    useEffect(() => {
        fetch(`${config.API_URL}/OM/api/order-created`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Data fetched successfully

                setORDM_OrderStatus(data[0].EnumVal);
            })
            .catch(error => {
                // Error occurred during fetch

            });
    }, []);
    async function insertNotification(data) {
        try {
            const response = await fetch(`${config.API_URL}/OM/api/notification`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Error inserting data');
            }

            const result = await response.json();

            return result;
        } catch (error) {

            throw error;
        }
    }

    function formatDateForAudit(date) {
        const d = new Date(date);
        const pad = (n) => (n < 10 ? '0' + n : n);

        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1); // months are 0-based
        const year = d.getFullYear();

        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }


    const handleConfirmation = async () => {
        setIsSaving(false);
        if (orderTableData.length === 0) {

            if (!selectedProductName) {
                document.getElementById('prdname').style.display = 'inline';
                document.getElementById('prdname').style.color = 'red';
            }
            if (!orderQuantity) {
                document.getElementById('ordq').style.display = 'inline';
                document.getElementById('ordq').style.color = 'red';
            }
            if (!selectedorderType) {
                document.getElementById('ordtype').style.display = 'inline';
                document.getElementById('ordtype').style.color = 'red';
            }
            if (!selectedScpName) {
                document.getElementById('tscp').style.display = 'inline';
                document.getElementById('tscp').style.color = 'red';
            }
            if (!selectedfromScpName) {
                document.getElementById('fscp').style.display = 'inline'
                document.getElementById('fscp').style.color = 'red'
            }
            // If any of the above fields are missing, stop execution
            if (!selectedProductName || !orderQuantity || !selectedorderType || !selectedScpName || !selectedfromScpName) {
                setIsSaving(false);
                return;
            }

            // Now check the table data
            if (orderTableData.length === 0) {
                toast.error(
                    "At least one product is required to save the order.",
                    {
                        onClose: () => {
                            setIsSaving(false);
                        }
                    }
                );
                return;
            }
            setIsSaving(false);
            return;
        } else {
            if (editingRowIndex == null) {
                setshowconfimationModal(true);
            } else {
                document.getElementById('editingrowindex').style.display = 'inline';
                document.getElementById('editingrowindex').style.color = 'red';
                setIsSaving(false);
            }
        }
    }
    // console.lo
    const handleSave = async (SCPs) => {
        logAction(`HandleSave (): Started`);
        setIsSaving(true); // 🔥 Start loading
        // await sleep(5000); // wait for 5 seconds

        if (orderTableData.length === 0) {

            if (!selectedProductName) {
                document.getElementById('prdname').style.display = 'inline';
                document.getElementById('prdname').style.color = 'red';
            }
            if (!orderQuantity) {
                document.getElementById('ordq').style.display = 'inline';
                document.getElementById('ordq').style.color = 'red';
            }
            if (!selectedorderType) {
                document.getElementById('ordtype').style.display = 'inline';
                document.getElementById('ordtype').style.color = 'red';
            }
            if (!selectedScpName) {
                document.getElementById('tscp').style.display = 'inline';
                document.getElementById('tscp').style.color = 'red';
            }
            if (!selectedfromScpName) {
                document.getElementById('fscp').style.display = 'inline'
                document.getElementById('fscp').style.color = 'red'
            }
            // If any of the above fields are missing, stop execution
            if (!selectedProductName || !orderQuantity || !selectedorderType || !selectedScpName || !selectedfromScpName) {
                setIsSaving(false);
                return;
            }

            // Now check the table data
            if (orderTableData.length === 0) {
                toast.error(
                    "At least one product is required to save the order.",
                    {
                        onClose: () => {
                            setIsSaving(false);
                        }
                    }
                );
                return;
            }
            setIsSaving(false);
            return;
        } else {


            if (editingRowIndex == null) {


                if (selectedOrderType.length === 0) {
                    document.getElementById('ordtype').style.color = 'red';
                    document.getElementById('ordtype').style.display = 'inline';
                    toast.error("Please Select OrderDate and OrderType.");
                    await sleep(200);
                    setIsSaving(false);
                    return;
                }

                try {
                    // 🧩 Step 1: Generate Order Number
                    let apiUrl = "";
                    let payload = {};

                    if (BYSCP === 0) {
                        apiUrl = `${config.API_URL}/OM/omso/ordernumbergenerate`;
                        payload = {

                            companycode: companyCode
                        };
                    } else {
                        apiUrl = `${config.API_URL}/OM/api/ordernumbergenerate`;
                        payload = data;
                    }


                    const orderNumResponse = await axios.post(apiUrl, payload);

                    const ordnum = orderNumResponse.data?.newOrderNumber;
                    if (!ordnum) {
                        throw new Error("Order number not generated");
                    }



                    // 🧩 Step 2: Validate Table Data
                    if (orderTableData.length === 0) {
                        alert('Please select at least one order to save.');
                        await sleep(500);
                        setIsSaving(false);
                        return;
                    }

                    // 🧩 Step 3: Prepare Order Payload
                    const selectedScp = filteredScpNames.find(scp => scp.SCPM_Name === selectedScpName);
                    const SCP_ID = selectedScpName;


                    const newScpName1 = selectedScpName
                    console.log("🔎 newScpName:", newScpName1);
                    console.log("📌 filteredScpNames:", filteredScpNames);
                    console.log("selectedScp:", selectedScp, "SCP_ID:", SCP_ID);
                    const orderType = orderTableData[0].OrderType;

                    // Scheme details (same as before)
                    let appliedSchemeDetails = null;
                    if (selectedSchemeId && appliedSchemes[selectedSchemeId]) {
                        const appliedScheme = appliedSchemes[selectedSchemeId];
                        const scheme = schemes.find(s => s.SM_ID === selectedSchemeId);
                        const freeProducts = (appliedScheme.freeProducts || []).map(fp => ({
                            ProductID: fp.freeProductId || fp.ProductID || fp.productid,
                            ProductName: fp.freeProductName || fp.ProductName,
                            FreeQuantity: fp.freeQuantity || fp.FreeQuantity,
                            freeProductCode: fp.ProductCode
                        }));

                        appliedSchemeDetails = {
                            SchemeID: scheme?.SM_ID || null,
                            SchemeName: scheme?.SM_SchemeName || "Unknown",
                            SchemeType: scheme?.SM_Type || "Unknown",
                            Discount: appliedScheme.discount || null,
                            GiftArticle: appliedScheme.giftArticle ? {
                                name: appliedScheme.giftArticle.name,
                                quantity: appliedScheme.giftArticle.quantity
                            } : null,
                            FreeProducts: freeProducts
                        };
                    }

                    // 🧩 Step 4: Post Order
                    const orderPayload = {
                        ORDM_OrderNumber: ordnum,
                        ORDM_OrderDate: orderDate,
                        ORDM_FromSCPID: parseInt(BYSCP) === 0 ? selectedfromScpName : selectedScpId,
                        ORDM_ToSCPID: SCP_ID,
                        ORDM_Type: orderType,
                        ORDM_CreatedBy: UM_UserId,
                        ORDM_CompanyGrpId: UM_CompanyGrpID,
                        ORDM_CompanyID: UM_CompanyID,
                        orderMasterItems: orderTableData.map(item => ({
                            ORDIT_ProductID: item.productid || item.ProductId,
                            ORDIT_OrderQTY: parseFloat(item.OrderQuantity),
                            ORDIT_CreatedBy: UM_UserId,
                            ORDIT_CompanyGrpId: UM_CompanyGrpID,
                            ORDIT_CompanyID: UM_CompanyID
                        })),
                        schemeDetails: appliedSchemeDetails
                    };



                    const response = await fetch(`${config.API_URL}/OM/order`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(orderPayload)
                    });

                    if (!response.ok) throw new Error("Error saving order data");

                    const result = await response.json();


                    toast.success(`Order : ${ordnum} saved successfully.`, { onClose: () => { handleReset(); setIsSaving(false); } });

                    await sleep(500);


                } catch (error) {
                    console.error("❌ Error in save process:", error);
                    toast.error("Something went wrong");
                    setIsSaving(false);
                }
            } else {
                document.getElementById('editingrowindex').style.display = 'inline';
                document.getElementById('editingrowindex').style.color = 'red';
                await sleep(500);
                setIsSaving(false);
            }
        }

        logAction(`HandleSave (): Ended`)

    };

    const handleOpenDatePicker = () => {
        setIsOpen(true);
    };


    const handleOrderTypeChange = (e) => {
        //ordnumgen(data);
        const newData = orderTableData.map(item => ({
            ...item,
            OrderType: e.target.value
        }));
        let value = e.target.value;
        console.log("order type value:", value);
        setOrderTableData(newData)
        setSelectedOrderType(e.target.value)
        if (value !== 2)
            setOffersFetched(true);
        else
            setOffersFetched(false);
        setOrderTypeTemp(true)
        setselectedorderType(e.target.value)
        if (e.target.value > 0) {
            document.getElementById('ordtype').style.display = 'none';
            document.getElementById('ordtype').style.color = 'red';
        } else if (value == "") {
            // document.getElementById('ordtype').style.display = 'inline';
            // document.getElementById('ordtype').style.color = 'red';
        } else {
            document.getElementById('ordtype').style.display = 'inline';
            document.getElementById('ordtype').style.color = 'red';
        }
        logAction(`Order Type Change():${e.target.value}`)
    }

    // Reusable function to fetch schemes
    const fetchSchemesForSCP = async (fromSCPID, toSCPID) => {
        try {
            if (!fromSCPID || !toSCPID) {
                toast.warning("Invalid SCP IDs. Cannot fetch schemes.");
                return [];
            }

            // Reset old offers
            setOffersFetched(false);
            setSchemes([]);
            setSchemeData([]);
            setIsSchemeModalOpen(false);



            const response = await axios.post(`${config.API_URL}/OM/schemes`, {
                SM_FromSCPID: fromSCPID,
                SSM_SCPID: toSCPID,
            });

            const fetchedSchemes = response.data?.data || [];

            setSchemes(fetchedSchemes);
            if (selectedOrderType !== 2) {
                setOffersFetched(true);
            }


            return fetchedSchemes;
        } catch (error) {
            console.error("❌ Error fetching schemes:", error);
            toast.error("Failed to fetch offers for the selected SCP.");
            return [];
        }
    };

    const handleChangetoscp = async (selectedOption) => {
        //ordnumgen(data);

        const SCP_ID = selectedOption?.target?.value || null;   // ⬅ ID only
        setSelectedScpName(SCP_ID);                            // ⬅ store ID

        document.getElementById('tscp').style.display = 'none';
        logAction(`To SCP Change(): ${SCP_ID}`);

        if (!SCP_ID || !selectedfromScpName) return;

        await fetchSchemesForSCP(
            SCP_ID,
            parseInt(BYSCP) === 0 ? selectedfromScpName : selectedScpId  // see note below
        );
    };

    const fetchScpmCode = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/OM/scpcode/scpmaster/${selectedScpId}`);
            setscpcode(response.data.SCPM_Code);

            return response.data.SCPM_Code
        } catch (error) {
            // setError(error.message);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                handleReset();
                const code = await fetchScpmCode();
                setscpcode(code);

                const data = {
                    scp: selectedScpId,
                    code: code,
                };



                // 🧹 Always clear previous order number before doing anything
                setord(undefined);

                if (BYSCP !== 0) {

                    await ordnumgen(data); // Wait for completion
                } else {
                    // 🚫 Skip and clear ord value
                    setord("");

                }
            } catch (error) {
                console.error("❌ Error in useEffect:", error);

                setord(undefined); // Ensure it's cleared on error too
            }
        };

        fetchData();
    }, [selectedScpId, BYSCP]); // ✅ Include BYSCP as dependency



    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const data = {
        scp: selectedScpId,
        code: scpcode
    }
    useEffect(() => {
        // Ensuring the selected order type is always the first option if it's not set
        if (!selectedorderType && options.length > 0) {
            setSelectedOrderType(options[0].EnumVal);
        }
    }, [options, selectedorderType]);



    const getSortedSchemes = (schemeData, selectedSchemeId) => {
        // normalize selected id to string for safe comparison
        const selId = selectedSchemeId == null ? null : String(selectedSchemeId);

        // Helper: parse various date inputs into a local end-of-day Date
        const parseLocalEndDate = (dateInput) => {
            if (!dateInput) return null;

            // If already a Date
            if (dateInput instanceof Date && !isNaN(dateInput)) {
                const d = new Date(dateInput.getTime());
                d.setHours(23, 59, 59, 999);
                return d;
            }

            // If string like "DD-MM-YYYY" or "D-M-YYYY"
            if (typeof dateInput === "string") {
                const dashParts = dateInput.split("-");
                if (dashParts.length === 3) {
                    // detect whether format is DD-MM-YYYY or YYYY-MM-DD (simple heuristic)
                    const [p1, p2, p3] = dashParts.map((s) => s.trim());
                    // if first part has length 4 -> assume YYYY-MM-DD
                    if (p1.length === 4) {
                        const y = Number(p1), m = Number(p2), d = Number(p3);
                        if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(d))
                            return new Date(y, m - 1, d, 23, 59, 59, 999);
                    } else {
                        // assume DD-MM-YYYY
                        const d = Number(p1), m = Number(p2), y = Number(p3);
                        if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(d))
                            return new Date(y, m - 1, d, 23, 59, 59, 999);
                    }
                }

                // fallback: try Date constructor (ISO etc.)
                const parsed = new Date(dateInput);
                if (!isNaN(parsed)) {
                    parsed.setHours(23, 59, 59, 999);
                    return parsed;
                }

                return null;
            }

            // fallback: attempt to construct Date
            try {
                const d = new Date(dateInput);
                if (!isNaN(d)) {
                    d.setHours(23, 59, 59, 999);
                    return d;
                }
            } catch (e) {
                /* ignore */
            }
            return null;
        };

        // localToday at midnight (local)
        const now = new Date();
        const localToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        // Enrich schemes with parsed fields so sort and UI can reuse
        const enriched = (schemeData || []).map((s) => {
            const endDate = parseLocalEndDate(s.SM_EndDate);
            const diffDays = endDate ? Math.ceil((endDate - localToday) / (1000 * 60 * 60 * 24)) : null;
            const expiryLabel = diffDays === 1 ? "Ends today" : diffDays === 2 ? "Ends Tomorrow" : "";
            const expiryColor = diffDays === 1 ? "#dc3545" : diffDays === 2 ? "#fd7e14" : "";
            return {
                ...s,
                __endDate: endDate,
                __diffDays: diffDays,
                __expiryLabel: expiryLabel,
                __expiryColor: expiryColor,
                __isApplied: selId != null && String(s.SM_ID) === selId,
                __isEligible: !!s.isEligible,
            };
        });

        // Priority function (lower number = higher precedence)
        const getPriority = (sch) => {
            const applied = sch.__isApplied;
            const eligible = sch.__isEligible;
            const diffDays = sch.__diffDays;

            const endsToday = diffDays === 1;
            const endsIn2 = diffDays === 2;

            // If applied: Applied first, then ends today, then Ends Tomorrow, then eligible
            if (applied) {
                if (applied) return 1;
                if (eligible) return 2;
                if (diffDays === 1) return 3;
                if (diffDays === 2) return 4;

                return 5;
            }

            // If NOT applied: ends today, Ends Tomorrow, eligible, others
            if (!applied) {
                if (eligible) return 6;
                if (endsToday) return 7;
                if (endsIn2) return 8;

                return 9;
            }

            return 10;
        };

        const sorted = enriched.sort((a, b) => {
            const pa = getPriority(a);
            const pb = getPriority(b);
            if (pa !== pb) return pa - pb;

            // tie-breakers: earlier expiry first, then eligible first, then alphabetic
            if ((a.__diffDays || Infinity) !== (b.__diffDays || Infinity)) {
                return (a.__diffDays || Infinity) - (b.__diffDays || Infinity);
            }
            if (a.__isEligible !== b.__isEligible) return a.__isEligible ? -1 : 1;

            return (a.SM_SchemeName || "").localeCompare(b.SM_SchemeName || "");
        });



        return sorted;
    };

    // Usage:
    const sortedSchemes = getSortedSchemes(schemeData, selectedSchemeId);


    const tickerRef = useRef(null);
    useEffect(() => {
        if (!tickerRef.current) return;

        const ticker = tickerRef.current;
        const width = ticker.scrollWidth / 2; // because duplicated

        const speed = 100; // pixels per second (you can change this)
        const duration = width / speed;

        ticker.style.animation = `scrollTrain ${duration}s linear infinite`;
    }, [tickerMessages]);

    return (
        <>



            {isSaving && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height
                    zIndex: 9999 // Sit on top of the other elements
                }} />
            )}

            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className='main_container'>
                <div className="orderHeader d-flex align-items-center justify-content-between">


                    <h1 className="formHeading" style={{marginLeft:'5px'}}>
                        {parseInt(BYSCP) === 0
                            ? "Order Master (by Sales Officer)"
                            : "Order Master (by SCP)"}
                    </h1>

                    <div className="d-flex align-items-center">
                        {/* ⭐ Offers button */}
                        {offersFetched && (schemeData.length > 0 || schemes.length > 0) && (
                            <button
                                type="button"
                                className={`orderHeader_btn me-2 d-flex align-items-center justify-content-center position-relative
              `}
                                disabled={editingRowIndex !== null}
                                style={{
                                    fontWeight: 600,
                                    position: "relative",
                                    padding: "10px 24px",
                                    borderRadius: "8px",
                                    transition: "none", // stop color transition
                                    overflow: "visible", // allow badge to overflow outside button
                                }}
                                onClick={() => {
                                    if (orderTableData.length === 0) {
                                        setSchemeData(schemes.map((s) => ({ ...s, isEligible: false })));
                                    } else {
                                        if (schemeData.length === 0) {
                                            const eligibleSchemes = schemes.filter((scheme) =>
                                                isSchemeEligible(scheme, orderTableData)
                                            );
                                            const enriched = schemes.map((scheme) => ({
                                                ...scheme,
                                                isEligible: eligibleSchemes.some(
                                                    (el) => String(el.SM_ID) === String(scheme.SM_ID)
                                                ),
                                            }));
                                            setSchemeData(enriched);
                                        }
                                    }
                                    setIsSchemeModalOpen(true);
                                }}
                            >
                                <span>APPLY OFFERS</span>

                                {/* 🔴 Badge positioned at top-right corner */}
                                {(() => {
                                    const eligibleCount = schemeData.filter((s) => s.isEligible).length;
                                    if (eligibleCount > 0)
                                        return (
                                            <span
                                                className="badge bg-danger offer-badge position-absolute"
                                                style={{
                                                    top: "-8px",
                                                    right: "-8px",
                                                    fontSize: "0.7rem",
                                                    padding: "4px 7px",
                                                    borderRadius: "50%",
                                                    animation: "pulseBadge 1.5s infinite",
                                                    transformOrigin: "center",
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                {eligibleCount}
                                            </span>
                                        );
                                })()}
                            </button>
                        )}

                        <style jsx>{`
  @keyframes pulseBadge {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.25);
      opacity: 0.85;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
                        `}</style>

                        {/* 📋 Use Order Template button */}
                        {BYSCP !== 0 && (
                            <button
                                onClick={usePopup}
                                className="orderHeader_btn d-flex align-items-center"
                                disabled={editingRowIndex !== null}
                            >
                                &nbsp;&nbsp;&nbsp; USE ORDER TEMPLATE
                            </button>
                        )}

                    </div>
                </div>

                <div className='your-form-container'>
                    <div className="row mb-4" >

                        <div className="col-md-3">
                            <label htmlFor="orderNumber" className="">Order Number</label>
                            <input type="text" id="orderNumber" value={ord} readOnly className="order-number-input form-input" style={{
                                backgroundColor: '#f2f2f2',
                                color: '#6c757d',
                                cursor: 'not-allowed',
                                userSelect: 'none'
                            }}
                                autoComplete="off" />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="orderDate">Order Date</label>
                            <div
                                className="select-container_list"
                                onClick={handleOpenDatePicker}
                            // style={{ cursor: 'pointer' }}
                            >
                                <DatePicker
                                    id="orderDate"
                                    selected={new Date(orderDate)}
                                    onChange={handleOrderDateChange}
                                    minDate={new Date()}
                                    //maxDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    className="routing_select-box"
                                    disabled={isDateDisabled || editingRowIndex !== null}
                                    dropdownMode="select"
                                    onKeyDown={e => e.preventDefault()}

                                />
                                <div
                                    className="icon-container_list myList"
                                    onClick={(e) => {
                                        if (editingRowIndex !== null) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            return;
                                        }

                                    }}
                                    style={{ cursor: editingRowIndex !== null ? 'not-allowed' : 'pointer' }}
                                >
                                    <i><IoCalendarOutline /></i>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="orderType" className="">Order Type</label><strong style={{ display: 'none' }} id="ordtype">*</strong>
                            {/* <div className='select-container'>
                            <OrderDropdown
                                options={orderTypes}
                                value={selectedorderType}
                                onChange={handleOrderTypeChange}
                                name="orderType"
                                placeholder="New Order"
                                idKey="EnumVal"
                                displayKey="Description"
                                disabled={isDateDisabled || editingRowIndex !== null || isToDropdownDisabled}

                            />



                        </div> */}
                            <div className="select-container_list">

                                <ReactSelectDropDown
                                    name="orderType"
                                    options={orderTypes}
                                    value={selectedorderType}                          // Only the value
                                    onChange={handleOrderTypeChange} // Full object returned
                                    placeholder="New Order"
                                    idKey="EnumVal"                                    // must match your mapping
                                    displayKey="Description"
                                    disabled={isDateDisabled || editingRowIndex !== null || isToDropdownDisabled}
                                    onMenuOpen={() => handleSelectOpen("orderType")}
                                    onMenuClose={handleSelectClose}
                                    className="routing_select-box"
                                />

                            </div>
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="orderStatus">Order Status</label>
                            <strong style={{ display: 'none' }} id="ordtype">*</strong>

                            <input
                                id="orderStatus"
                                value={Status || ''}
                                autoComplete="off"
                                disabled
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    color: '#6c757d',
                                    cursor: 'not-allowed'
                                }}
                            />
                        </div>


                    </div>

                    {/* {offersFetched && orderTableData.length > 0 && tickerMessages.length > 0 && (
                    <div className="offer-ticker-wrapper"  >
                        <div className="offer-ticker " ref={tickerRef}>
                             Duplicate messages twice for seamless loop */}
                    {/*<div className="ticker-content ">
                                {tickerMessages.map((msg, idx) => (
                                    <span key={`msg1-${idx}`} className="ticker-item">
                                        {msg} &nbsp;|
                                    </span>
                                ))}
                            </div>

                            <div className="ticker-content">
                                {tickerMessages.map((msg, idx) => (
                                    <span key={`msg2-${idx}`} className="ticker-item">
                                        {msg} &nbsp;|
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                )} */}

                    {offersFetched &&
                        orderTableData.length > 0 &&
                        tickerMessages.length > 0 && (
                            <div className="offer-ticker-wrapper">
                                <div
                                    className="offer-ticker"
                                    ref={tickerRef}
                                >
                                    <div className="ticker-content flex-1">
                                        {tickerMessages.map((msg, idx) => (
                                            <span key={`msg1-${idx}`} className="ticker-item">
                                                {msg}
                                            </span>
                                        ))}
                                        <span
                                            aria-hidden="true"
                                            style={{ display: "inline-block", width: "40vw" }}
                                        />
                                    </div>

                                    <div className="ticker-content flex-1">
                                        {tickerMessages.map((msg, idx) => (
                                            <span key={`msg2-${idx}`} className="ticker-item">
                                                {msg}
                                            </span>
                                        ))}
                                        <span
                                            aria-hidden="true"
                                            style={{ display: "inline-block", width: "40vw" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}



                    {selectedSchemeId && appliedSchemes[selectedSchemeId] && (
                        <div
                            className="border-0 p-4 mb-3 rounded-xl shadow-sm reward-card animate-fadeIn"
                            style={{
                                borderRadius: "12px",
                                background: "linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)",
                                position: "relative",
                                overflow: "hidden",
                                boxShadow: "0 4px 12px rgba(16, 185, 129, 0.08)",
                                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-2px)";
                                e.currentTarget.style.boxShadow = "0 8px 20px rgba(16, 185, 129, 0.15)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.08)";
                            }}
                        >
                            {/* Animated Pulse Background */}
                            <div
                                className="absolute inset-0 opacity-30 pointer-events-none"
                                style={{
                                    background:
                                        "radial-gradient(circle at 20% 80%, rgba(34, 197, 94, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.25) 0%, transparent 50%)",
                                    animation: "pulse 6s ease-in-out infinite",
                                }}
                            />

                            <div className="flex items-center gap-2 mb-3">


                                {/* 🎉 Benefits Section */}
                                <h6 className="fw-bold text-success mb-2">
                                    🎉 Scheme Benefits
                                </h6>
                            </div>
                            <div className="space-y-3">
                                {(() => {
                                    const reward = appliedSchemes[selectedSchemeId];
                                    const schemeInfo = schemes.find(s => s.SM_ID === selectedSchemeId) || {};
                                    const combinedReward = { ...reward, ...schemeInfo };

                                    return (
                                        <div

                                            className="group p-3 rounded-lg bg-white/70 backdrop-blur-sm border border-emerald-100 transition-all duration-200 hover:bg-white hover:shadow-md"
                                            style={{
                                                borderBottom: "1px dashed #a7f3d0",
                                            }}
                                        >

                                            <div className="font-semibold text-emerald-800 text-base flex items-center gap-1.5">
                                                <span className="text-emerald-600">✦</span>  {combinedReward.SM_SchemeName || "Scheme Details"}
                                            </div>



                                            {combinedReward.SM_SchemeDescription && (

                                                <p className="text-sm text-gray-600 mt-1 leading-relaxed">
                                                    {combinedReward.SM_SchemeDescription}
                                                </p>



                                            )}



                                            {/* 💰 Discount */}
                                            {reward.discount && (
                                                <div className="d-flex align-items-center mb-1">
                                                    <span className="me-2">💰</span>
                                                    <span>
                                                        You will receive a{' '}
                                                        <strong>
                                                            {reward.discount}
                                                            {reward.DiscountType === 1
                                                                ? ' %'
                                                                : reward.DiscountType === 2
                                                                    ? ' Rs.'
                                                                    : ''}
                                                        </strong>{' '}
                                                        discount
                                                    </span>
                                                </div>

                                            )}

                                            {/* 🎁 Gift Article */}
                                            {reward.giftArticle && (
                                                <div className="d-flex align-items-center mb-1">
                                                    <span className="me-2">🎁</span>
                                                    <span>
                                                        You will receive{" "}
                                                        <strong>
                                                            {reward.giftArticle.quantity} × {reward.giftArticle.name}
                                                        </strong>{" "}
                                                        as a gift article
                                                    </span>
                                                </div>
                                            )}

                                            {/* 🆓 Free Products */}
                                            {reward.freeProducts?.length > 0 && (
                                                <div>
                                                    {reward.freeProducts.map((fp, idx) => (
                                                        <div key={idx} className="d-flex align-items-center mb-1">
                                                            <span className="me-2">🆓</span>
                                                            <span>
                                                                You will receive{" "}
                                                                <strong>
                                                                    {fp.freeQuantity} quantity of {fp.freeProductName}
                                                                </strong>{" "}
                                                                as free
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>

                                            )}
                                        </div>

                                    );
                                })()}
                            </div>
                        </div>
                    )}

                    {/* {editingRowIndex !== null && (
                    <div className="global-edit-overlay" />
                )} */}


                    <div className="border p-3">



                        <div className="row g-3">
                            <div className="col">


                                {BYSCP === 1 ? (
                                    <>
                                        <label htmlFor="scpName" className="label1">From</label>

                                        <div className="d-grid">
                                            <input
                                                type="text"
                                                id="scpName"
                                                value={selectedfromScpName || ""}
                                                readOnly
                                                className="form-input"

                                                style={{
                                                    backgroundColor: '#f2f2f2',
                                                    color: '#6c757d',
                                                    cursor: 'not-allowed',
                                                }}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <label htmlFor="scpName" className="label1">From<strong style={{ display: 'none' }} id="fscp">*</strong></label>

                                        <div className="select-container_list" style={{ cursor: isToDropdownDisabled ? 'not-allowed' : 'pointer' }}>
                                            <ReactSelectDropDown
                                                id="scpname"
                                                key={dropdownKeyfscp}
                                                name="scpname"
                                                options={OptionsFromScp}
                                                value={selectedFromScp}
                                                onChange={handleFromScpChange}
                                                placeholder="--Select--"
                                                idKey="value"          // key used in OptionsFromScp (modify if needed)
                                                displayKey="label"     // label used in OptionsFromScp (modify if needed)
                                                disabled={isToDropdownDisabled}
                                                className="routing_select-box"
                                                enableScrollEffect={true}
                                            />

                                        </div>

                                    </>
                                )}
                            </div>

                            <div className="col" >
                                <label htmlFor="scpName" className="label1">To<strong style={{ display: 'none' }} id="tscp">*</strong></label>
                                <div
                                    className="select-container_list"
                                    style={{ cursor: isToDropdownDisabled ? 'not-allowed' : 'pointer' }}
                                >
                                    {BYSCP === 1 ? (
                                        // 🧩 Case 1: When BYSCP === 1
                                        <ReactSelectDropDown
                                            key={dropdownKey}
                                            name="ToSCP_Name"
                                            options={options}
                                            value={selectedScpName}                          // Only the value
                                            onChange={(option) => handleChangetoscp(option)} // Full object returned
                                            placeholder="--Select--"
                                            idKey="value"                                    // must match your mapping
                                            displayKey="label"
                                            disabled={isToDropdownDisabled}                  // disable support ✔
                                            onMenuOpen={() => handleSelectOpen("tscp")}
                                            onMenuClose={handleSelectClose}
                                            className="routing_select-box"
                                            enableScrollEffect={true}
                                        />

                                    ) : (
                                        // 🧩 Case 2: When BYSCP !== 1
                                        <ReactSelectDropDown
                                            key={dropdownKey}
                                            name="ToSCP_Name"
                                            options={options}
                                            value={selectedScpName}                          // pass ONLY value
                                            onChange={(option) => handleChangetoscp(option)} // full option received
                                            placeholder="--Select--"
                                            idKey="value"                                    // your mapped key
                                            displayKey="label"                               // your mapped key
                                            disabled={isToDropdownDisabled}
                                            onMenuOpen={() => handleSelectOpen("tscp")}
                                            onMenuClose={handleSelectClose}
                                            className="routing_select-box"
                                        />
                                    )}


                                </div>
                            </div>
                            <div className="col">
                                <label htmlFor="productName" className="label1">
                                    Product Name
                                    <strong style={{ display: 'none' }} id="prdname">*</strong>
                                </label>
                                {/* Select dropdown container */}
                                <div className="select-container_list">

                                    <ReactSelectDropDown
                                        key={dropdownKeyprdname}
                                        name="productName"
                                        options={optionsproduct}
                                        value={selectedProductName}                          // Only the value
                                        onChange={handleProductNameChange} // Full object returned
                                        placeholder="--Select--"
                                        idKey="value"                                    // must match your mapping
                                        displayKey="label"
                                        disabled={editingRowIndex !== null}               // disable support ✔
                                        onMenuOpen={() => handleSelectOpen("productName")}
                                        onMenuClose={handleSelectClose}
                                        className="routing_select-box"
                                        enableScrollEffect={orderTableData.length > 0 ? false : true}
                                    />

                                </div>
                            </div>

                            <div className="col">
                                <label htmlFor="orderQuantity" className="label1">Order Quantity<strong style={{ display: 'none' }} id="ordq">*</strong></label>
                                <input
                                    type="text"
                                    id="orderQuantity"
                                    className="form-input"
                                    autoComplete="off"
                                    value={orderQuantity}
                                    onChange={handleChangeOrderQuantity}
                                    disabled={editingRowIndex !== null}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor="availableQuantity" className="label1">Available Quantity</label>
                                <input
                                    className="form-input"
                                    id="availableQuantity"
                                    value={totalPackSize}
                                    autoComplete="off"
                                    readOnly
                                    style={{
                                        backgroundColor: '#f2f2f2',
                                        color: '#6c757d',
                                        cursor: 'not-allowed'
                                    }}
                                />
                            </div>
                        </div>


                        {isSchemeModalOpen && (
                            <div className="popup_overlay">
                                <div className="popup">
                                    <div>
                                        <Link onClick={() => setIsSchemeModalOpen(false)} state={{ BYSCP }}><Image src={x} alt="x" className="x" /></Link>
                                    </div>
                                    <h3 className="modal-title">
                                        Available Schemes
                                    </h3>

                                    <div>
                                        <table className="tableClass">
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Scheme Name</th>
                                                    <th>Description</th>
                                                    <th>Apply</th>
                                                </tr>
                                            </thead>
                                            <tbody>


                                                {sortedSchemes.map((scheme, index) => {
                                                    const isSelected = selectedSchemeId === scheme.SM_ID;
                                                    const reward = appliedSchemes[scheme.SM_ID];
                                                    let endDate;
                                                    // Parse DD-MM-YYYY manually to avoid UTC issues


                                                    if (scheme.SM_EndDate instanceof Date) {
                                                        endDate = new Date(scheme.SM_EndDate.getTime());
                                                    } else {
                                                        endDate = new Date(scheme.SM_EndDate);
                                                    }


                                                    endDate.setHours(23, 59, 59, 999);


                                                    const today = new Date();
                                                    const localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate()); // ✅ local midnight

                                                    const diffTime = endDate - localToday;
                                                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));



                                                    let expiryLabel = "";
                                                    let expiryColor = "";

                                                    if (diffDays === 1) {
                                                        expiryLabel = "Ends today";
                                                        expiryColor = "#dc3545";
                                                    } else if (diffDays === 2) {
                                                        expiryLabel = "Ends Tomorrow";
                                                        expiryColor = "#fd7e14";
                                                    }


                                                    return (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                backgroundColor: isSelected ? "#a7f7d2ff" : "transparent",
                                                                opacity: scheme.isSchemeApplied === 0 ? 0.6 : 1,
                                                                transition: "background-color 0.25s ease",
                                                            }}
                                                        >
                                                            <td>{index + 1}</td>

                                                            <td>
                                                                <div>
                                                                    <span
                                                                        style={{
                                                                            fontWeight: reward ? "600" : "500",
                                                                        }}
                                                                    >
                                                                        {scheme.SM_SchemeName}
                                                                    </span>
                                                                    {expiryLabel && (
                                                                        <span
                                                                            style={{
                                                                                backgroundColor: expiryColor,
                                                                                color: "#fff",
                                                                                borderRadius: "4px",
                                                                                padding: "2px 8px",
                                                                                fontSize: "11px",
                                                                                fontWeight: "500",
                                                                                whiteSpace: "nowrap",
                                                                                marginLeft: "8px",
                                                                            }}
                                                                        >
                                                                            {expiryLabel}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </td>

                                                            <td
                                                                style={{
                                                                    padding: "12px 8px",
                                                                    border: "1px solid #ddd",
                                                                }}
                                                            >
                                                                <div>{scheme.SM_SchemeDescription}</div>


                                                            </td>

                                                            <td
                                                                style={{
                                                                    padding: "12px 8px",
                                                                    border: "1px solid #ddd",
                                                                    textAlign: "center",
                                                                    verticalAlign: "middle",
                                                                }}
                                                            >
                                                                <button
                                                                    onClick={(e) => {
                                                                        // Trigger ripple from click position
                                                                        const button = e.currentTarget;
                                                                        const rect = button.getBoundingClientRect();
                                                                        const x = e.clientX - rect.left;
                                                                        const y = e.clientY - rect.top;

                                                                        // Create ripple
                                                                        const ripple = document.createElement("span");
                                                                        const size = Math.max(rect.width, rect.height);
                                                                        ripple.style.width = ripple.style.height = `${size}px`;
                                                                        ripple.style.left = `${x - size / 2}px`;
                                                                        ripple.style.top = `${y - size / 2}px`;
                                                                        ripple.style.position = "absolute";
                                                                        ripple.style.borderRadius = "50%";
                                                                        ripple.style.background = "rgba(255, 255, 255, 0.6)";
                                                                        ripple.style.transform = "scale(0)";
                                                                        ripple.style.animation = "ripple 0.6s ease-out";
                                                                        ripple.style.pointerEvents = "none";
                                                                        button.appendChild(ripple);

                                                                        // Remove ripple after animation
                                                                        setTimeout(() => ripple.remove(), 600);

                                                                        // Add tap scale animation
                                                                        button.style.transform = "scale(0.92)";
                                                                        setTimeout(() => {
                                                                            button.style.transform = "";
                                                                        }, 150);

                                                                        // Your original logic
                                                                        if (!scheme.isEligible && !isSelected) {

                                                                            return;
                                                                        }

                                                                        if (isSelected) {
                                                                            setSelectedSchemeId(null);
                                                                            setAppliedSchemes({});

                                                                        } else {
                                                                            handleApplyScheme(scheme);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: "42px",
                                                                        height: "42px",
                                                                        borderRadius: "50%",
                                                                        backgroundColor: isSelected
                                                                            ? "#10b981"
                                                                            : scheme.isEligible
                                                                                ? "#fff"
                                                                                : "#f3f4f6",
                                                                        border: isSelected
                                                                            ? "2px solid #059669"        // ✅ green when selected
                                                                            : scheme.isEligible
                                                                                ? "2.5px solid #1d4b73"        // ✅ darker blue border when eligible
                                                                                : "2px solid #9c9898ff",     // gray when not eligible
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        cursor: isSelected || scheme.isEligible ? "pointer" : "not-allowed",
                                                                        opacity: isSelected || scheme.isEligible ? 1 : 0.6,
                                                                        transition: "all 0.15s ease, transform 0.15s ease",
                                                                        margin: "0 auto",
                                                                        position: "relative",
                                                                        overflow: "hidden", // Important for ripple containment
                                                                        outline: "none",
                                                                    }}
                                                                    title={
                                                                        isSelected
                                                                            ? "Click to remove this scheme"
                                                                            : !scheme.isEligible
                                                                                ? "You are not eligible for this scheme"
                                                                                : "Click to apply this scheme"
                                                                    }
                                                                >
                                                                    {isSelected ? (
                                                                        <span style={{ color: "#fff", fontSize: "18px", fontWeight: "bold" }}>✓</span>
                                                                    ) : (
                                                                        <Check
                                                                            size={26}
                                                                            color={scheme.isEligible ? "#295a80" : "#b0b0b0"}
                                                                            strokeWidth={scheme.isEligible ? 5 : 3}
                                                                        />
                                                                    )}
                                                                </button>

                                                                {/* Add this style to your component or global CSS */}
                                                                <style jsx>{`
    @keyframes ripple {
      to {
        transform: scale(2);
        opacity: 0;
      }
    }
  `}</style>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div
                                        style={{
                                            marginTop: "24px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >

                                        {/* <div style={{ display: "flex", gap: "10px" }}>
                                        
                                        <button
                                            style={{
                                                backgroundColor: "#10b981",
                                                border: "none",
                                                padding: "10px 20px",
                                                borderRadius: "6px",
                                                color: "#fff",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                            }}
                                            onClick={() => {
                                                if (!selectedSchemeId) {
                                                    toast.warning("Please select a scheme before saving.");
                                                    return;
                                                }
                                                setIsSchemeModalOpen(false);
                                             
                                            }}
                                        >
                                            SAVE & APPLY
                                        </button>
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        )}





                        <div className="p-3">
                            <div className="col-auto d-flex justify-content-end">
                                <button className="order_addbtn1" onClick={handleOrderSubmit} disabled={editingRowIndex !== null}>
                                    ADD
                                </button>

                            </div>

                        </div>
                        {/* </div> */}

                    </div>
                    {/* </div> */}
                    {orderTableData && orderTableData.length > 0 && (
                        <div className="table_container mt-3">
                            <table className="order_tableClass">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Product Name</th>
                                        <th>Product Code</th>
                                        <th>Order Quantity</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* 🔹 Main order rows */}
                                    {orderTableData.map((item, index) => {
                                        const freeQty =
                                            Object.values(appliedSchemes || {})
                                                .flatMap((scheme) => scheme.freeProducts || [])
                                                .find(
                                                    (fp) =>
                                                        String(fp.SFPM_ProductID || fp.freeProductId || fp.productid) ===
                                                        String(item.productid) ||
                                                        String(fp.PL_ProductName || fp.freeProductName) ===
                                                        String(item.ProductName)
                                                )?.freeQuantity || 0;

                                        // 🔹 Find any schemes where this product is a required one
                                        const almostEligibleScheme = (schemes || []).find((scheme) =>
                                            scheme.requiredProducts?.some(
                                                (sp) => String(sp.SPM_ProductID) === String(item.productid)
                                            )
                                        );

                                        let qtyToEligibility = null;

                                        if (almostEligibleScheme) {
                                            const requiredProduct = almostEligibleScheme.requiredProducts.find(
                                                (sp) => String(sp.SPM_ProductID) === String(item.productid)
                                            );

                                            const requiredQty = parseFloat(requiredProduct?.SPM_Quantity || 0);
                                            const currentQty = parseFloat(item.OrderQuantity || 0);

                                            if (currentQty < requiredQty) {
                                                qtyToEligibility = requiredQty - currentQty;
                                            }
                                        }


                                        return (
                                            <tr
                                                key={index}
                                                className={
                                                    editingRowIndex !== null
                                                        ? editingRowIndex === index
                                                            ? "active-editing-row"
                                                            : "blurred-row"
                                                        : ""
                                                }
                                            >

                                                <td>{index + 1}</td>
                                                <td className="productnametable">{item.ProductName}</td>
                                                <td>{item.productcode}</td>

                                                {editingRowIndex === index ? (
                                                    <td>
                                                        <input
                                                            type="number"
                                                            id="editingrowindexinput"
                                                            className="editingrowindex"
                                                            value={tempOrderQuantity}
                                                            onChange={handleInputChange}
                                                            autoComplete="off"
                                                            min="1" // prevent 0 or negative numbers
                                                            inputMode="numeric"
                                                            ref={inputRef}
                                                            onWheel={(e) => e.target.blur()} // Disable scroll-to-change
                                                            onKeyDown={(e) => {
                                                                // prevent typing e, +, -, . for cleaner number-only input
                                                                if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                                                            }}
                                                        />
                                                        {tempOrderQuantity === "" && (
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                    position: "absolute",
                                                                    top: "50%",
                                                                    right: "-10px",
                                                                    transform: "translateY(-50%)",
                                                                    fontWeight: "bold",
                                                                }}
                                                            >
                                                                *
                                                            </span>
                                                        )}
                                                    </td>
                                                ) : (
                                                    <td className="orderquantitytable">

                                                        {item.OrderQuantity}
                                                        {freeQty > 0 && (
                                                            <span style={{ color: "green", fontWeight: "500" }}>
                                                                {" "}+ {freeQty} (Free)
                                                            </span>
                                                        )}
                                                    </td>
                                                )}

                                                <td className='justify-content-center display-flex align-items-center'>
                                                    {editingRowIndex === index ? (
                                                        <>
                                                            <img
                                                                className="editicon"
                                                                src={accept}
                                                                alt="save"
                                                                title="Save"
                                                                onClick={handleSaveClick}
                                                                style={{ height: "16px", width: "16px" }}
                                                            />
                                                            <strong style={{ display: "none", marginRight: "10px" }} id="editingrowindex">
                                                                *
                                                            </strong>
                                                        </>
                                                    ) : (
                                                        <img
                                                            className="editicon"
                                                            title="Edit"
                                                            src={Icon3}
                                                            alt="edit"
                                                            onClick={() => handleEditClick(index)}
                                                        />
                                                    )}
                                                    <img
                                                        className="bi bi-x-lg form-button-remove"
                                                        src={Icon5}
                                                        title="Remove"
                                                        alt="Remove"
                                                        onClick={() => handleRemove(index)}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    {/* 🔹 Add free-only rows (only for products NOT already in orderTableData) */}
                                    {Object.values(appliedSchemes || {})
                                        .flatMap((scheme) => scheme.freeProducts || [])
                                        .filter((fp) => {
                                            const freeId = String(fp.SFPM_ProductID || fp.freeProductId || fp.productid);
                                            const existsInOrder = orderTableData.some(
                                                (item) =>
                                                    String(item.productid) === freeId ||
                                                    String(item.ProductName) === String(fp.freeProductName) ||
                                                    String(item.PL_ProductId) === freeId
                                            );
                                            return !existsInOrder;
                                        })
                                        .map((fp, index) => (
                                            <tr
                                                key={`free-${index}`}
                                                style={{ backgroundColor: "#f5fff5" }}
                                            >
                                                <td>{orderTableData.length + index + 1}</td>
                                                <td className="productnametable">{fp.freeProductName}</td>
                                                <td>{fp.freeProductCode}</td>
                                                <td style={{ color: "green", fontWeight: "500" }}>
                                                    {fp.freeQuantity} (Free)
                                                </td>
                                                <td>—</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                </div>
            </div>


            {/* ================== MODALS ================== */}
            {showconfimationModal && (
                <div className="popup_overlay">
                    <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4>Are you sure you want to save the Order : {ord} ?</h4>
                        <div className="popup_btn_container">
                            <button
                                className="yes_btn"
                                onClick={() => {
                                    setshowconfimationModal(false);
                                    handleSave();
                                }}
                            >
                                YES
                            </button>

                            <button
                                className="no_btn"
                                onClick={() => { setshowconfimationModal(false); setIsSaving(false); }}
                            >
                                NO
                            </button>

                        </div>
                    </div>
                </div>
            )}


            <div className="button-container">
                {BYSCP !== 0 && (
                    <button
                        className="order_savebtn"
                        onClick={openPopup}
                        disabled={editingRowIndex !== null}
                    >
                        SAVE AS ORDER TEMPLATE
                    </button>
                )}

                <button className="save_btn" onClick={handleConfirmation}  >
                    SAVE
                </button>

                <button className="reset_btn" onClick={handleReset} disabled={editingRowIndex !== null}>
                    RESET
                </button>
                {/* /dashboard */}

                {/* <Link to={`/dashboard/orderlist`} className="list_btn" onClick={() => logAction(`Redirecting (): LIST PAGE`)} disabled = {editingRowIndex !== null}>
                    LIST
                </Link> */}
                <Link
                    to="/dashboard/orderlist"
                    className="list_btn"
                    state={{ BYSCP }}
                    onClick={(e) => {
                        if (editingRowIndex !== null) {
                            e.preventDefault(); // Stop navigation
                        } else {
                            logAction(`Redirecting (): LIST PAGE`);
                        }
                    }}
                    style={{
                        pointerEvents: editingRowIndex !== null ? 'none' : 'auto',
                        cursor: editingRowIndex !== null ? 'not-allowed' : 'pointer'
                    }}
                >
                    LIST
                </Link>
            </div>
            {/* <OrderPopup
                isOpen={isOrderPopupOpen} onClose={closePopup} /> */}
        </>
    );
};
export default OrderForm;
